/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-mixed-operators, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars, default-case, jsdoc/require-param*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
var $Object = $util.global.Object, $undefined = $util.global.undefined, $Error = $util.global.Error, $TypeError = $util.global.TypeError, $String = $util.global.String, $Number = $util.global.Number, $Array = $util.global.Array, $Boolean = $util.global.Boolean, $parseInt = $util.global.parseInt, $BigInt = $util.global.BigInt;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.chat = (function() {

    /**
     * Namespace chat.
     * @exports chat
     * @namespace
     */
    var chat = {};

    chat.ChatServer = (function() {

        /**
         * Constructs a new ChatServer service.
         * @memberof chat
         * @classdesc Represents a ChatServer
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        var ChatServer = function(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        };

        (ChatServer.prototype = $Object.create($protobuf.rpc.Service.prototype)).constructor = ChatServer;

        /**
         * Creates new ChatServer service using the specified rpc implementation.
         * @function create
         * @memberof chat.ChatServer
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ChatServer} RPC service. Useful where requests and/or responses are streamed.
         */
        ChatServer.create = function(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link chat.ChatServer#login}.
         * @memberof chat.ChatServer
         * @typedef LoginCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.Welcome} [response] Welcome
         */

        /**
         * Calls Login.
         * @memberof chat.ChatServer
         * @typedef Login
         * @type {{
         *   (request: chat.ILoginRequest, callback: chat.ChatServer.LoginCallback): void;
         *   (request: chat.ILoginRequest): Promise<chat.Welcome>;
         *   readonly name: "Login";
         *   readonly path: "/chat.ChatServer/Login";
         *   readonly requestType: "LoginRequest";
         *   readonly responseType: "Welcome";
         *   readonly requestStream: undefined;
         *   readonly responseStream: undefined;
         * }}
         */

        /**
         * Calls Login.
         * @name chat.ChatServer#login
         * @type {chat.ChatServer.Login}
         */
        $Object.defineProperties(ChatServer.prototype.login = function(request, callback) {
            return $protobuf.rpc.Service.prototype.rpcCall.call(this, ChatServer.prototype.login, $root.chat.LoginRequest, $root.chat.Welcome, request, callback);
        }, {
            name: { value: "Login" },
            path: { value: "/chat.ChatServer/Login" },
            requestType: { value: "LoginRequest" },
            responseType: { value: "Welcome" },
            requestStream: { value: $undefined },
            responseStream: { value: $undefined }
        });

        /**
         * Callback as used by {@link chat.ChatServer#sendMessage}.
         * @memberof chat.ChatServer
         * @typedef SendMessageCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.ChatMessage} [response] ChatMessage
         */

        /**
         * Calls SendMessage.
         * @memberof chat.ChatServer
         * @typedef SendMessage
         * @type {{
         *   (request: chat.ISendChatMessageRequest, callback: chat.ChatServer.SendMessageCallback): void;
         *   (request: chat.ISendChatMessageRequest): Promise<chat.ChatMessage>;
         *   readonly name: "SendMessage";
         *   readonly path: "/chat.ChatServer/SendMessage";
         *   readonly requestType: "SendChatMessageRequest";
         *   readonly responseType: "ChatMessage";
         *   readonly requestStream: undefined;
         *   readonly responseStream: undefined;
         * }}
         */

        /**
         * Calls SendMessage.
         * @name chat.ChatServer#sendMessage
         * @type {chat.ChatServer.SendMessage}
         */
        $Object.defineProperties(ChatServer.prototype.sendMessage = function(request, callback) {
            return $protobuf.rpc.Service.prototype.rpcCall.call(this, ChatServer.prototype.sendMessage, $root.chat.SendChatMessageRequest, $root.chat.ChatMessage, request, callback);
        }, {
            name: { value: "SendMessage" },
            path: { value: "/chat.ChatServer/SendMessage" },
            requestType: { value: "SendChatMessageRequest" },
            responseType: { value: "ChatMessage" },
            requestStream: { value: $undefined },
            responseStream: { value: $undefined }
        });

        /**
         * Callback as used by {@link chat.ChatServer#listChats}.
         * @memberof chat.ChatServer
         * @typedef ListChatsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.Chat} [response] Chat
         */

        /**
         * Calls ListChats.
         * @memberof chat.ChatServer
         * @typedef ListChats
         * @type {{
         *   (request: chat.IListChatsRequest, callback: chat.ChatServer.ListChatsCallback): void;
         *   (request: chat.IListChatsRequest): Promise<chat.Chat>;
         *   readonly name: "ListChats";
         *   readonly path: "/chat.ChatServer/ListChats";
         *   readonly requestType: "ListChatsRequest";
         *   readonly responseType: "Chat";
         *   readonly requestStream: undefined;
         *   readonly responseStream: true;
         * }}
         */

        /**
         * Calls ListChats.
         * @name chat.ChatServer#listChats
         * @type {chat.ChatServer.ListChats}
         */
        $Object.defineProperties(ChatServer.prototype.listChats = function(request, callback) {
            return $protobuf.rpc.Service.prototype.rpcCall.call(this, ChatServer.prototype.listChats, $root.chat.ListChatsRequest, $root.chat.Chat, request, callback);
        }, {
            name: { value: "ListChats" },
            path: { value: "/chat.ChatServer/ListChats" },
            requestType: { value: "ListChatsRequest" },
            responseType: { value: "Chat" },
            requestStream: { value: $undefined },
            responseStream: { value: true }
        });

        /**
         * Callback as used by {@link chat.ChatServer#replay}.
         * @memberof chat.ChatServer
         * @typedef ReplayCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.ChatMessage} [response] ChatMessage
         */

        /**
         * Calls Replay.
         * @memberof chat.ChatServer
         * @typedef Replay
         * @type {{
         *   (request: chat.IReplayRequest, callback: chat.ChatServer.ReplayCallback): void;
         *   (request: chat.IReplayRequest): Promise<chat.ChatMessage>;
         *   readonly name: "Replay";
         *   readonly path: "/chat.ChatServer/Replay";
         *   readonly requestType: "ReplayRequest";
         *   readonly responseType: "ChatMessage";
         *   readonly requestStream: undefined;
         *   readonly responseStream: true;
         * }}
         */

        /**
         * Calls Replay.
         * @name chat.ChatServer#replay
         * @type {chat.ChatServer.Replay}
         */
        $Object.defineProperties(ChatServer.prototype.replay = function(request, callback) {
            return $protobuf.rpc.Service.prototype.rpcCall.call(this, ChatServer.prototype.replay, $root.chat.ReplayRequest, $root.chat.ChatMessage, request, callback);
        }, {
            name: { value: "Replay" },
            path: { value: "/chat.ChatServer/Replay" },
            requestType: { value: "ReplayRequest" },
            responseType: { value: "ChatMessage" },
            requestStream: { value: $undefined },
            responseStream: { value: true }
        });

        /**
         * Callback as used by {@link chat.ChatServer#readMessage}.
         * @memberof chat.ChatServer
         * @typedef ReadMessageCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.Ack} [response] Ack
         */

        /**
         * Calls ReadMessage.
         * @memberof chat.ChatServer
         * @typedef ReadMessage
         * @type {{
         *   (request: chat.IMessageReadRequest, callback: chat.ChatServer.ReadMessageCallback): void;
         *   (request: chat.IMessageReadRequest): Promise<chat.Ack>;
         *   readonly name: "ReadMessage";
         *   readonly path: "/chat.ChatServer/ReadMessage";
         *   readonly requestType: "MessageReadRequest";
         *   readonly responseType: "Ack";
         *   readonly requestStream: undefined;
         *   readonly responseStream: undefined;
         * }}
         */

        /**
         * Calls ReadMessage.
         * @name chat.ChatServer#readMessage
         * @type {chat.ChatServer.ReadMessage}
         */
        $Object.defineProperties(ChatServer.prototype.readMessage = function(request, callback) {
            return $protobuf.rpc.Service.prototype.rpcCall.call(this, ChatServer.prototype.readMessage, $root.chat.MessageReadRequest, $root.chat.Ack, request, callback);
        }, {
            name: { value: "ReadMessage" },
            path: { value: "/chat.ChatServer/ReadMessage" },
            requestType: { value: "MessageReadRequest" },
            responseType: { value: "Ack" },
            requestStream: { value: $undefined },
            responseStream: { value: $undefined }
        });

        return ChatServer;
    })();

    chat.Response = (function() {

        /**
         * Properties of a Response.
         * @typedef {Object} chat.Response.$Properties
         * @property {chat.Welcome.$Properties|null} [welcome] Response welcome
         * @property {chat.Chat.$Properties|null} [chat] Response chat
         * @property {chat.ChatMessage.$Properties|null} [message] Response message
         * @property {chat.Error.$Properties|null} [error] Response error
         * @property {chat.Ack.$Properties|null} [ack] Response ack
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Response.
         * @memberof chat
         * @interface IResponse
         * @augments chat.Response.$Properties
         * @deprecated Use chat.Response.$Properties instead.
         */

        /**
         * Shape of a Response.
         * @typedef {{
         *   welcome?: chat.Welcome.$Shape|null;
         *   chat?: chat.Chat.$Shape|null;
         *   message?: chat.ChatMessage.$Shape|null;
         *   error?: chat.Error.$Shape|null;
         *   ack?: chat.Ack.$Shape|null;
         *   $unknowns?: Array.<Uint8Array>;
         * }} chat.Response.$Shape
         */

        /**
         * Constructs a new Response.
         * @memberof chat
         * @classdesc Represents a Response.
         * @constructor
         * @param {chat.Response.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var Response = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Response welcome.
         * @member {chat.Welcome.$Properties|null|undefined} welcome
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.welcome = null;

        /**
         * Response chat.
         * @member {chat.Chat.$Properties|null|undefined} chat
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.chat = null;

        /**
         * Response message.
         * @member {chat.ChatMessage.$Properties|null|undefined} message
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.message = null;

        /**
         * Response error.
         * @member {chat.Error.$Properties|null|undefined} error
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.error = null;

        /**
         * Response ack.
         * @member {chat.Ack.$Properties|null|undefined} ack
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.ack = null;

        /**
         * Creates a new Response instance using the specified properties.
         * @function create
         * @memberof chat.Response
         * @static
         * @param {chat.Response.$Properties=} [properties] Properties to set
         * @returns {chat.Response} Response instance
         * @type {{
         *   (properties: chat.Response.$Shape): chat.Response & chat.Response.$Shape;
         *   (properties?: chat.Response.$Properties): chat.Response;
         * }}
         */
        Response.create = function(properties) {
            return new Response(properties);
        };

        /**
         * Encodes the specified Response message. Does not implicitly {@link chat.Response.verify|verify} messages.
         * @function encode
         * @memberof chat.Response
         * @static
         * @param {chat.Response.$Properties} message Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Response.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.welcome != null && $Object.hasOwnProperty.call(message, "welcome"))
                $root.chat.Welcome.encode(message.welcome, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.chat != null && $Object.hasOwnProperty.call(message, "chat"))
                $root.chat.Chat.encode(message.chat, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
            if (message.message != null && $Object.hasOwnProperty.call(message, "message"))
                $root.chat.ChatMessage.encode(message.message, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
            if (message.error != null && $Object.hasOwnProperty.call(message, "error"))
                $root.chat.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.ack != null && $Object.hasOwnProperty.call(message, "ack"))
                $root.chat.Ack.encode(message.ack, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Response message, length delimited. Does not implicitly {@link chat.Response.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Response
         * @static
         * @param {chat.Response.$Properties} message Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Response.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Response message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Response & chat.Response.$Shape} Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Response.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.Response(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        message.welcome = $root.chat.Welcome.decode(reader, reader.uint32(), $undefined, _depth + 1, message.welcome);
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        message.chat = $root.chat.Chat.decode(reader, reader.uint32(), $undefined, _depth + 1, message.chat);
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.message = $root.chat.ChatMessage.decode(reader, reader.uint32(), $undefined, _depth + 1, message.message);
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.error = $root.chat.Error.decode(reader, reader.uint32(), $undefined, _depth + 1, message.error);
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        message.ack = $root.chat.Ack.decode(reader, reader.uint32(), $undefined, _depth + 1, message.ack);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a Response message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Response & chat.Response.$Shape} Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Response.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Response message.
         * @function verify
         * @memberof chat.Response
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Response.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.welcome != null && $Object.hasOwnProperty.call(message, "welcome")) {
                var error = $root.chat.Welcome.verify(message.welcome, _depth + 1);
                if (error)
                    return "welcome." + error;
            }
            if (message.chat != null && $Object.hasOwnProperty.call(message, "chat")) {
                var error = $root.chat.Chat.verify(message.chat, _depth + 1);
                if (error)
                    return "chat." + error;
            }
            if (message.message != null && $Object.hasOwnProperty.call(message, "message")) {
                var error = $root.chat.ChatMessage.verify(message.message, _depth + 1);
                if (error)
                    return "message." + error;
            }
            if (message.error != null && $Object.hasOwnProperty.call(message, "error")) {
                var error = $root.chat.Error.verify(message.error, _depth + 1);
                if (error)
                    return "error." + error;
            }
            if (message.ack != null && $Object.hasOwnProperty.call(message, "ack")) {
                var error = $root.chat.Ack.verify(message.ack, _depth + 1);
                if (error)
                    return "ack." + error;
            }
            return null;
        };

        /**
         * Creates a Response message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Response
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Response} Response
         */
        Response.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.Response)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.Response: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.Response();
            if (object.welcome != null) {
                if (!$util.isObject(object.welcome))
                    throw $TypeError(".chat.Response.welcome: object expected");
                message.welcome = $root.chat.Welcome.fromObject(object.welcome, _depth + 1);
            }
            if (object.chat != null) {
                if (!$util.isObject(object.chat))
                    throw $TypeError(".chat.Response.chat: object expected");
                message.chat = $root.chat.Chat.fromObject(object.chat, _depth + 1);
            }
            if (object.message != null) {
                if (!$util.isObject(object.message))
                    throw $TypeError(".chat.Response.message: object expected");
                message.message = $root.chat.ChatMessage.fromObject(object.message, _depth + 1);
            }
            if (object.error != null) {
                if (!$util.isObject(object.error))
                    throw $TypeError(".chat.Response.error: object expected");
                message.error = $root.chat.Error.fromObject(object.error, _depth + 1);
            }
            if (object.ack != null) {
                if (!$util.isObject(object.ack))
                    throw $TypeError(".chat.Response.ack: object expected");
                message.ack = $root.chat.Ack.fromObject(object.ack, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a Response message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Response
         * @static
         * @param {chat.Response} message Response
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Response.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults) {
                object.welcome = null;
                object.chat = null;
                object.message = null;
                object.error = null;
                object.ack = null;
            }
            if (message.welcome != null && $Object.hasOwnProperty.call(message, "welcome"))
                object.welcome = $root.chat.Welcome.toObject(message.welcome, options, _depth + 1);
            if (message.chat != null && $Object.hasOwnProperty.call(message, "chat"))
                object.chat = $root.chat.Chat.toObject(message.chat, options, _depth + 1);
            if (message.message != null && $Object.hasOwnProperty.call(message, "message"))
                object.message = $root.chat.ChatMessage.toObject(message.message, options, _depth + 1);
            if (message.error != null && $Object.hasOwnProperty.call(message, "error"))
                object.error = $root.chat.Error.toObject(message.error, options, _depth + 1);
            if (message.ack != null && $Object.hasOwnProperty.call(message, "ack"))
                object.ack = $root.chat.Ack.toObject(message.ack, options, _depth + 1);
            return object;
        };

        /**
         * Converts this Response to JSON.
         * @function toJSON
         * @memberof chat.Response
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Response.prototype.toJSON = function() {
            return Response.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Response
         * @function getTypeUrl
         * @memberof chat.Response
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Response.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.Response";
        };

        return Response;
    })();

    chat.Ack = (function() {

        /**
         * Properties of an Ack.
         * @typedef {Object} chat.Ack.$Properties
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an Ack.
         * @memberof chat
         * @interface IAck
         * @augments chat.Ack.$Properties
         * @deprecated Use chat.Ack.$Properties instead.
         */

        /**
         * Shape of an Ack.
         * @typedef {chat.Ack.$Properties} chat.Ack.$Shape
         */

        /**
         * Constructs a new Ack.
         * @memberof chat
         * @classdesc Represents an Ack.
         * @constructor
         * @param {chat.Ack.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var Ack = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Creates a new Ack instance using the specified properties.
         * @function create
         * @memberof chat.Ack
         * @static
         * @param {chat.Ack.$Properties=} [properties] Properties to set
         * @returns {chat.Ack} Ack instance
         * @type {{
         *   (properties: chat.Ack.$Shape): chat.Ack & chat.Ack.$Shape;
         *   (properties?: chat.Ack.$Properties): chat.Ack;
         * }}
         */
        Ack.create = function(properties) {
            return new Ack(properties);
        };

        /**
         * Encodes the specified Ack message. Does not implicitly {@link chat.Ack.verify|verify} messages.
         * @function encode
         * @memberof chat.Ack
         * @static
         * @param {chat.Ack.$Properties} message Ack message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ack.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Ack message, length delimited. Does not implicitly {@link chat.Ack.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Ack
         * @static
         * @param {chat.Ack.$Properties} message Ack message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ack.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an Ack message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Ack
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Ack & chat.Ack.$Shape} Ack
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ack.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.Ack();
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                reader.skipType(tag & 7, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes an Ack message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Ack
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Ack & chat.Ack.$Shape} Ack
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ack.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Ack message.
         * @function verify
         * @memberof chat.Ack
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Ack.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            return null;
        };

        /**
         * Creates an Ack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Ack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Ack} Ack
         */
        Ack.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.Ack)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.Ack: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            return new $root.chat.Ack();
        };

        /**
         * Creates a plain object from an Ack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Ack
         * @static
         * @param {chat.Ack} message Ack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Ack.toObject = function () {
            return {};
        };

        /**
         * Converts this Ack to JSON.
         * @function toJSON
         * @memberof chat.Ack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Ack.prototype.toJSON = function() {
            return Ack.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Ack
         * @function getTypeUrl
         * @memberof chat.Ack
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Ack.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.Ack";
        };

        return Ack;
    })();

    chat.Welcome = (function() {

        /**
         * Properties of a Welcome.
         * @typedef {Object} chat.Welcome.$Properties
         * @property {string|null} [version] Welcome version
         * @property {number|null} [usersOnline] Welcome usersOnline
         * @property {chat.Avatar.$Properties|null} [avatar] Welcome avatar
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Welcome.
         * @memberof chat
         * @interface IWelcome
         * @augments chat.Welcome.$Properties
         * @deprecated Use chat.Welcome.$Properties instead.
         */

        /**
         * Shape of a Welcome.
         * @typedef {chat.Welcome.$Properties} chat.Welcome.$Shape
         */

        /**
         * Constructs a new Welcome.
         * @memberof chat
         * @classdesc Represents a Welcome.
         * @constructor
         * @param {chat.Welcome.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var Welcome = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Welcome version.
         * @member {string} version
         * @memberof chat.Welcome
         * @instance
         */
        Welcome.prototype.version = "";

        /**
         * Welcome usersOnline.
         * @member {number} usersOnline
         * @memberof chat.Welcome
         * @instance
         */
        Welcome.prototype.usersOnline = 0;

        /**
         * Welcome avatar.
         * @member {chat.Avatar.$Properties|null|undefined} avatar
         * @memberof chat.Welcome
         * @instance
         */
        Welcome.prototype.avatar = null;

        /**
         * Creates a new Welcome instance using the specified properties.
         * @function create
         * @memberof chat.Welcome
         * @static
         * @param {chat.Welcome.$Properties=} [properties] Properties to set
         * @returns {chat.Welcome} Welcome instance
         * @type {{
         *   (properties: chat.Welcome.$Shape): chat.Welcome & chat.Welcome.$Shape;
         *   (properties?: chat.Welcome.$Properties): chat.Welcome;
         * }}
         */
        Welcome.create = function(properties) {
            return new Welcome(properties);
        };

        /**
         * Encodes the specified Welcome message. Does not implicitly {@link chat.Welcome.verify|verify} messages.
         * @function encode
         * @memberof chat.Welcome
         * @static
         * @param {chat.Welcome.$Properties} message Welcome message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Welcome.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.version != null && $Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.version);
            if (message.usersOnline != null && $Object.hasOwnProperty.call(message, "usersOnline"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.usersOnline);
            if (message.avatar != null && $Object.hasOwnProperty.call(message, "avatar"))
                $root.chat.Avatar.encode(message.avatar, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Welcome message, length delimited. Does not implicitly {@link chat.Welcome.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Welcome
         * @static
         * @param {chat.Welcome.$Properties} message Welcome message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Welcome.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Welcome message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Welcome
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Welcome & chat.Welcome.$Shape} Welcome
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Welcome.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.Welcome(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.version = value;
                        else
                            delete message.version;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.usersOnline = value;
                        else
                            delete message.usersOnline;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.avatar = $root.chat.Avatar.decode(reader, reader.uint32(), $undefined, _depth + 1, message.avatar);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a Welcome message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Welcome
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Welcome & chat.Welcome.$Shape} Welcome
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Welcome.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Welcome message.
         * @function verify
         * @memberof chat.Welcome
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Welcome.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.version != null && $Object.hasOwnProperty.call(message, "version"))
                if (!$util.isString(message.version))
                    return "version: string expected";
            if (message.usersOnline != null && $Object.hasOwnProperty.call(message, "usersOnline"))
                if (!$util.isInteger(message.usersOnline))
                    return "usersOnline: integer expected";
            if (message.avatar != null && $Object.hasOwnProperty.call(message, "avatar")) {
                var error = $root.chat.Avatar.verify(message.avatar, _depth + 1);
                if (error)
                    return "avatar." + error;
            }
            return null;
        };

        /**
         * Creates a Welcome message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Welcome
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Welcome} Welcome
         */
        Welcome.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.Welcome)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.Welcome: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.Welcome();
            if (object.version != null)
                if (typeof object.version !== "string" || object.version.length)
                    message.version = $String(object.version);
            if (object.usersOnline != null)
                if ($Number(object.usersOnline) !== 0)
                    message.usersOnline = object.usersOnline | 0;
            if (object.avatar != null) {
                if (!$util.isObject(object.avatar))
                    throw $TypeError(".chat.Welcome.avatar: object expected");
                message.avatar = $root.chat.Avatar.fromObject(object.avatar, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a Welcome message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Welcome
         * @static
         * @param {chat.Welcome} message Welcome
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Welcome.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults) {
                object.version = "";
                object.usersOnline = 0;
                object.avatar = null;
            }
            if (message.version != null && $Object.hasOwnProperty.call(message, "version"))
                object.version = message.version;
            if (message.usersOnline != null && $Object.hasOwnProperty.call(message, "usersOnline"))
                object.usersOnline = message.usersOnline;
            if (message.avatar != null && $Object.hasOwnProperty.call(message, "avatar"))
                object.avatar = $root.chat.Avatar.toObject(message.avatar, options, _depth + 1);
            return object;
        };

        /**
         * Converts this Welcome to JSON.
         * @function toJSON
         * @memberof chat.Welcome
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Welcome.prototype.toJSON = function() {
            return Welcome.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Welcome
         * @function getTypeUrl
         * @memberof chat.Welcome
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Welcome.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.Welcome";
        };

        return Welcome;
    })();

    chat.Request = (function() {

        /**
         * Properties of a Request.
         * @typedef {Object} chat.Request.$Properties
         * @property {chat.LoginRequest.$Properties|null} [authenticate] Request authenticate
         * @property {chat.SendChatMessageRequest.$Properties|null} [sendMessage] Request sendMessage
         * @property {chat.ListChatsRequest.$Properties|null} [listChats] Request listChats
         * @property {chat.ReplayRequest.$Properties|null} [replay] Request replay
         * @property {chat.MessageReadRequest.$Properties|null} [messageRead] Request messageRead
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Request.
         * @memberof chat
         * @interface IRequest
         * @augments chat.Request.$Properties
         * @deprecated Use chat.Request.$Properties instead.
         */

        /**
         * Shape of a Request.
         * @typedef {{
         *   authenticate?: chat.LoginRequest.$Shape|null;
         *   sendMessage?: chat.SendChatMessageRequest.$Shape|null;
         *   listChats?: chat.ListChatsRequest.$Shape|null;
         *   replay?: chat.ReplayRequest.$Shape|null;
         *   messageRead?: chat.MessageReadRequest.$Shape|null;
         *   $unknowns?: Array.<Uint8Array>;
         * }} chat.Request.$Shape
         */

        /**
         * Constructs a new Request.
         * @memberof chat
         * @classdesc Represents a Request.
         * @constructor
         * @param {chat.Request.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var Request = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Request authenticate.
         * @member {chat.LoginRequest.$Properties|null|undefined} authenticate
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.authenticate = null;

        /**
         * Request sendMessage.
         * @member {chat.SendChatMessageRequest.$Properties|null|undefined} sendMessage
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.sendMessage = null;

        /**
         * Request listChats.
         * @member {chat.ListChatsRequest.$Properties|null|undefined} listChats
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.listChats = null;

        /**
         * Request replay.
         * @member {chat.ReplayRequest.$Properties|null|undefined} replay
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.replay = null;

        /**
         * Request messageRead.
         * @member {chat.MessageReadRequest.$Properties|null|undefined} messageRead
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.messageRead = null;

        /**
         * Creates a new Request instance using the specified properties.
         * @function create
         * @memberof chat.Request
         * @static
         * @param {chat.Request.$Properties=} [properties] Properties to set
         * @returns {chat.Request} Request instance
         * @type {{
         *   (properties: chat.Request.$Shape): chat.Request & chat.Request.$Shape;
         *   (properties?: chat.Request.$Properties): chat.Request;
         * }}
         */
        Request.create = function(properties) {
            return new Request(properties);
        };

        /**
         * Encodes the specified Request message. Does not implicitly {@link chat.Request.verify|verify} messages.
         * @function encode
         * @memberof chat.Request
         * @static
         * @param {chat.Request.$Properties} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.authenticate != null && $Object.hasOwnProperty.call(message, "authenticate"))
                $root.chat.LoginRequest.encode(message.authenticate, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.sendMessage != null && $Object.hasOwnProperty.call(message, "sendMessage"))
                $root.chat.SendChatMessageRequest.encode(message.sendMessage, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
            if (message.listChats != null && $Object.hasOwnProperty.call(message, "listChats"))
                $root.chat.ListChatsRequest.encode(message.listChats, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
            if (message.replay != null && $Object.hasOwnProperty.call(message, "replay"))
                $root.chat.ReplayRequest.encode(message.replay, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.messageRead != null && $Object.hasOwnProperty.call(message, "messageRead"))
                $root.chat.MessageReadRequest.encode(message.messageRead, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Request message, length delimited. Does not implicitly {@link chat.Request.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Request
         * @static
         * @param {chat.Request.$Properties} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Request message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Request & chat.Request.$Shape} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.Request(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        message.authenticate = $root.chat.LoginRequest.decode(reader, reader.uint32(), $undefined, _depth + 1, message.authenticate);
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        message.sendMessage = $root.chat.SendChatMessageRequest.decode(reader, reader.uint32(), $undefined, _depth + 1, message.sendMessage);
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.listChats = $root.chat.ListChatsRequest.decode(reader, reader.uint32(), $undefined, _depth + 1, message.listChats);
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.replay = $root.chat.ReplayRequest.decode(reader, reader.uint32(), $undefined, _depth + 1, message.replay);
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        message.messageRead = $root.chat.MessageReadRequest.decode(reader, reader.uint32(), $undefined, _depth + 1, message.messageRead);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a Request message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Request & chat.Request.$Shape} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Request message.
         * @function verify
         * @memberof chat.Request
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Request.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.authenticate != null && $Object.hasOwnProperty.call(message, "authenticate")) {
                var error = $root.chat.LoginRequest.verify(message.authenticate, _depth + 1);
                if (error)
                    return "authenticate." + error;
            }
            if (message.sendMessage != null && $Object.hasOwnProperty.call(message, "sendMessage")) {
                var error = $root.chat.SendChatMessageRequest.verify(message.sendMessage, _depth + 1);
                if (error)
                    return "sendMessage." + error;
            }
            if (message.listChats != null && $Object.hasOwnProperty.call(message, "listChats")) {
                var error = $root.chat.ListChatsRequest.verify(message.listChats, _depth + 1);
                if (error)
                    return "listChats." + error;
            }
            if (message.replay != null && $Object.hasOwnProperty.call(message, "replay")) {
                var error = $root.chat.ReplayRequest.verify(message.replay, _depth + 1);
                if (error)
                    return "replay." + error;
            }
            if (message.messageRead != null && $Object.hasOwnProperty.call(message, "messageRead")) {
                var error = $root.chat.MessageReadRequest.verify(message.messageRead, _depth + 1);
                if (error)
                    return "messageRead." + error;
            }
            return null;
        };

        /**
         * Creates a Request message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Request
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Request} Request
         */
        Request.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.Request)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.Request: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.Request();
            if (object.authenticate != null) {
                if (!$util.isObject(object.authenticate))
                    throw $TypeError(".chat.Request.authenticate: object expected");
                message.authenticate = $root.chat.LoginRequest.fromObject(object.authenticate, _depth + 1);
            }
            if (object.sendMessage != null) {
                if (!$util.isObject(object.sendMessage))
                    throw $TypeError(".chat.Request.sendMessage: object expected");
                message.sendMessage = $root.chat.SendChatMessageRequest.fromObject(object.sendMessage, _depth + 1);
            }
            if (object.listChats != null) {
                if (!$util.isObject(object.listChats))
                    throw $TypeError(".chat.Request.listChats: object expected");
                message.listChats = $root.chat.ListChatsRequest.fromObject(object.listChats, _depth + 1);
            }
            if (object.replay != null) {
                if (!$util.isObject(object.replay))
                    throw $TypeError(".chat.Request.replay: object expected");
                message.replay = $root.chat.ReplayRequest.fromObject(object.replay, _depth + 1);
            }
            if (object.messageRead != null) {
                if (!$util.isObject(object.messageRead))
                    throw $TypeError(".chat.Request.messageRead: object expected");
                message.messageRead = $root.chat.MessageReadRequest.fromObject(object.messageRead, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a Request message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Request
         * @static
         * @param {chat.Request} message Request
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Request.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults) {
                object.authenticate = null;
                object.sendMessage = null;
                object.listChats = null;
                object.replay = null;
                object.messageRead = null;
            }
            if (message.authenticate != null && $Object.hasOwnProperty.call(message, "authenticate"))
                object.authenticate = $root.chat.LoginRequest.toObject(message.authenticate, options, _depth + 1);
            if (message.sendMessage != null && $Object.hasOwnProperty.call(message, "sendMessage"))
                object.sendMessage = $root.chat.SendChatMessageRequest.toObject(message.sendMessage, options, _depth + 1);
            if (message.listChats != null && $Object.hasOwnProperty.call(message, "listChats"))
                object.listChats = $root.chat.ListChatsRequest.toObject(message.listChats, options, _depth + 1);
            if (message.replay != null && $Object.hasOwnProperty.call(message, "replay"))
                object.replay = $root.chat.ReplayRequest.toObject(message.replay, options, _depth + 1);
            if (message.messageRead != null && $Object.hasOwnProperty.call(message, "messageRead"))
                object.messageRead = $root.chat.MessageReadRequest.toObject(message.messageRead, options, _depth + 1);
            return object;
        };

        /**
         * Converts this Request to JSON.
         * @function toJSON
         * @memberof chat.Request
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Request.prototype.toJSON = function() {
            return Request.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Request
         * @function getTypeUrl
         * @memberof chat.Request
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Request.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.Request";
        };

        return Request;
    })();

    chat.LoginRequest = (function() {

        /**
         * Properties of a LoginRequest.
         * @typedef {Object} chat.LoginRequest.$Properties
         * @property {string|null} [sessionId] LoginRequest sessionId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a LoginRequest.
         * @memberof chat
         * @interface ILoginRequest
         * @augments chat.LoginRequest.$Properties
         * @deprecated Use chat.LoginRequest.$Properties instead.
         */

        /**
         * Shape of a LoginRequest.
         * @typedef {chat.LoginRequest.$Properties} chat.LoginRequest.$Shape
         */

        /**
         * Constructs a new LoginRequest.
         * @memberof chat
         * @classdesc Represents a LoginRequest.
         * @constructor
         * @param {chat.LoginRequest.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var LoginRequest = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * LoginRequest sessionId.
         * @member {string} sessionId
         * @memberof chat.LoginRequest
         * @instance
         */
        LoginRequest.prototype.sessionId = "";

        /**
         * Creates a new LoginRequest instance using the specified properties.
         * @function create
         * @memberof chat.LoginRequest
         * @static
         * @param {chat.LoginRequest.$Properties=} [properties] Properties to set
         * @returns {chat.LoginRequest} LoginRequest instance
         * @type {{
         *   (properties: chat.LoginRequest.$Shape): chat.LoginRequest & chat.LoginRequest.$Shape;
         *   (properties?: chat.LoginRequest.$Properties): chat.LoginRequest;
         * }}
         */
        LoginRequest.create = function(properties) {
            return new LoginRequest(properties);
        };

        /**
         * Encodes the specified LoginRequest message. Does not implicitly {@link chat.LoginRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.LoginRequest
         * @static
         * @param {chat.LoginRequest.$Properties} message LoginRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LoginRequest.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sessionId);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified LoginRequest message, length delimited. Does not implicitly {@link chat.LoginRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.LoginRequest
         * @static
         * @param {chat.LoginRequest.$Properties} message LoginRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LoginRequest.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a LoginRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.LoginRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.LoginRequest & chat.LoginRequest.$Shape} LoginRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LoginRequest.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.LoginRequest(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.sessionId = value;
                        else
                            delete message.sessionId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a LoginRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.LoginRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.LoginRequest & chat.LoginRequest.$Shape} LoginRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LoginRequest.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LoginRequest message.
         * @function verify
         * @memberof chat.LoginRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LoginRequest.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId"))
                if (!$util.isString(message.sessionId))
                    return "sessionId: string expected";
            return null;
        };

        /**
         * Creates a LoginRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.LoginRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.LoginRequest} LoginRequest
         */
        LoginRequest.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.LoginRequest)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.LoginRequest: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.LoginRequest();
            if (object.sessionId != null)
                if (typeof object.sessionId !== "string" || object.sessionId.length)
                    message.sessionId = $String(object.sessionId);
            return message;
        };

        /**
         * Creates a plain object from a LoginRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.LoginRequest
         * @static
         * @param {chat.LoginRequest} message LoginRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LoginRequest.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults)
                object.sessionId = "";
            if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId"))
                object.sessionId = message.sessionId;
            return object;
        };

        /**
         * Converts this LoginRequest to JSON.
         * @function toJSON
         * @memberof chat.LoginRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LoginRequest.prototype.toJSON = function() {
            return LoginRequest.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for LoginRequest
         * @function getTypeUrl
         * @memberof chat.LoginRequest
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        LoginRequest.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.LoginRequest";
        };

        return LoginRequest;
    })();

    chat.ReplayRequest = (function() {

        /**
         * Properties of a ReplayRequest.
         * @typedef {Object} chat.ReplayRequest.$Properties
         * @property {string|null} [replayFrom] ReplayRequest replayFrom
         * @property {string|null} [chatId] ReplayRequest chatId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a ReplayRequest.
         * @memberof chat
         * @interface IReplayRequest
         * @augments chat.ReplayRequest.$Properties
         * @deprecated Use chat.ReplayRequest.$Properties instead.
         */

        /**
         * Shape of a ReplayRequest.
         * @typedef {chat.ReplayRequest.$Properties} chat.ReplayRequest.$Shape
         */

        /**
         * Constructs a new ReplayRequest.
         * @memberof chat
         * @classdesc Represents a ReplayRequest.
         * @constructor
         * @param {chat.ReplayRequest.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var ReplayRequest = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * ReplayRequest replayFrom.
         * @member {string} replayFrom
         * @memberof chat.ReplayRequest
         * @instance
         */
        ReplayRequest.prototype.replayFrom = "";

        /**
         * ReplayRequest chatId.
         * @member {string} chatId
         * @memberof chat.ReplayRequest
         * @instance
         */
        ReplayRequest.prototype.chatId = "";

        /**
         * Creates a new ReplayRequest instance using the specified properties.
         * @function create
         * @memberof chat.ReplayRequest
         * @static
         * @param {chat.ReplayRequest.$Properties=} [properties] Properties to set
         * @returns {chat.ReplayRequest} ReplayRequest instance
         * @type {{
         *   (properties: chat.ReplayRequest.$Shape): chat.ReplayRequest & chat.ReplayRequest.$Shape;
         *   (properties?: chat.ReplayRequest.$Properties): chat.ReplayRequest;
         * }}
         */
        ReplayRequest.create = function(properties) {
            return new ReplayRequest(properties);
        };

        /**
         * Encodes the specified ReplayRequest message. Does not implicitly {@link chat.ReplayRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.ReplayRequest
         * @static
         * @param {chat.ReplayRequest.$Properties} message ReplayRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplayRequest.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.replayFrom != null && $Object.hasOwnProperty.call(message, "replayFrom"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.replayFrom);
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ReplayRequest message, length delimited. Does not implicitly {@link chat.ReplayRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ReplayRequest
         * @static
         * @param {chat.ReplayRequest.$Properties} message ReplayRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplayRequest.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ReplayRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ReplayRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ReplayRequest & chat.ReplayRequest.$Shape} ReplayRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplayRequest.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.ReplayRequest(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.replayFrom = value;
                        else
                            delete message.replayFrom;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.chatId = value;
                        else
                            delete message.chatId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a ReplayRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ReplayRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ReplayRequest & chat.ReplayRequest.$Shape} ReplayRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplayRequest.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReplayRequest message.
         * @function verify
         * @memberof chat.ReplayRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReplayRequest.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.replayFrom != null && $Object.hasOwnProperty.call(message, "replayFrom"))
                if (!$util.isString(message.replayFrom))
                    return "replayFrom: string expected";
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            return null;
        };

        /**
         * Creates a ReplayRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ReplayRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ReplayRequest} ReplayRequest
         */
        ReplayRequest.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.ReplayRequest)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.ReplayRequest: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.ReplayRequest();
            if (object.replayFrom != null)
                if (typeof object.replayFrom !== "string" || object.replayFrom.length)
                    message.replayFrom = $String(object.replayFrom);
            if (object.chatId != null)
                if (typeof object.chatId !== "string" || object.chatId.length)
                    message.chatId = $String(object.chatId);
            return message;
        };

        /**
         * Creates a plain object from a ReplayRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ReplayRequest
         * @static
         * @param {chat.ReplayRequest} message ReplayRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReplayRequest.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults) {
                object.replayFrom = "";
                object.chatId = "";
            }
            if (message.replayFrom != null && $Object.hasOwnProperty.call(message, "replayFrom"))
                object.replayFrom = message.replayFrom;
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                object.chatId = message.chatId;
            return object;
        };

        /**
         * Converts this ReplayRequest to JSON.
         * @function toJSON
         * @memberof chat.ReplayRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReplayRequest.prototype.toJSON = function() {
            return ReplayRequest.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ReplayRequest
         * @function getTypeUrl
         * @memberof chat.ReplayRequest
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ReplayRequest.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.ReplayRequest";
        };

        return ReplayRequest;
    })();

    chat.ListChatsRequest = (function() {

        /**
         * Properties of a ListChatsRequest.
         * @typedef {Object} chat.ListChatsRequest.$Properties
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a ListChatsRequest.
         * @memberof chat
         * @interface IListChatsRequest
         * @augments chat.ListChatsRequest.$Properties
         * @deprecated Use chat.ListChatsRequest.$Properties instead.
         */

        /**
         * Shape of a ListChatsRequest.
         * @typedef {chat.ListChatsRequest.$Properties} chat.ListChatsRequest.$Shape
         */

        /**
         * Constructs a new ListChatsRequest.
         * @memberof chat
         * @classdesc Represents a ListChatsRequest.
         * @constructor
         * @param {chat.ListChatsRequest.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var ListChatsRequest = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Creates a new ListChatsRequest instance using the specified properties.
         * @function create
         * @memberof chat.ListChatsRequest
         * @static
         * @param {chat.ListChatsRequest.$Properties=} [properties] Properties to set
         * @returns {chat.ListChatsRequest} ListChatsRequest instance
         * @type {{
         *   (properties: chat.ListChatsRequest.$Shape): chat.ListChatsRequest & chat.ListChatsRequest.$Shape;
         *   (properties?: chat.ListChatsRequest.$Properties): chat.ListChatsRequest;
         * }}
         */
        ListChatsRequest.create = function(properties) {
            return new ListChatsRequest(properties);
        };

        /**
         * Encodes the specified ListChatsRequest message. Does not implicitly {@link chat.ListChatsRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.ListChatsRequest
         * @static
         * @param {chat.ListChatsRequest.$Properties} message ListChatsRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListChatsRequest.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ListChatsRequest message, length delimited. Does not implicitly {@link chat.ListChatsRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ListChatsRequest
         * @static
         * @param {chat.ListChatsRequest.$Properties} message ListChatsRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListChatsRequest.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ListChatsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ListChatsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ListChatsRequest & chat.ListChatsRequest.$Shape} ListChatsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListChatsRequest.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.ListChatsRequest();
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                reader.skipType(tag & 7, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a ListChatsRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ListChatsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ListChatsRequest & chat.ListChatsRequest.$Shape} ListChatsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListChatsRequest.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListChatsRequest message.
         * @function verify
         * @memberof chat.ListChatsRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListChatsRequest.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            return null;
        };

        /**
         * Creates a ListChatsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ListChatsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ListChatsRequest} ListChatsRequest
         */
        ListChatsRequest.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.ListChatsRequest)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.ListChatsRequest: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            return new $root.chat.ListChatsRequest();
        };

        /**
         * Creates a plain object from a ListChatsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ListChatsRequest
         * @static
         * @param {chat.ListChatsRequest} message ListChatsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListChatsRequest.toObject = function () {
            return {};
        };

        /**
         * Converts this ListChatsRequest to JSON.
         * @function toJSON
         * @memberof chat.ListChatsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListChatsRequest.prototype.toJSON = function() {
            return ListChatsRequest.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ListChatsRequest
         * @function getTypeUrl
         * @memberof chat.ListChatsRequest
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ListChatsRequest.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.ListChatsRequest";
        };

        return ListChatsRequest;
    })();

    chat.MessageReadRequest = (function() {

        /**
         * Properties of a MessageReadRequest.
         * @typedef {Object} chat.MessageReadRequest.$Properties
         * @property {string|null} [chatId] MessageReadRequest chatId
         * @property {string|null} [messageId] MessageReadRequest messageId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a MessageReadRequest.
         * @memberof chat
         * @interface IMessageReadRequest
         * @augments chat.MessageReadRequest.$Properties
         * @deprecated Use chat.MessageReadRequest.$Properties instead.
         */

        /**
         * Shape of a MessageReadRequest.
         * @typedef {chat.MessageReadRequest.$Properties} chat.MessageReadRequest.$Shape
         */

        /**
         * Constructs a new MessageReadRequest.
         * @memberof chat
         * @classdesc Represents a MessageReadRequest.
         * @constructor
         * @param {chat.MessageReadRequest.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var MessageReadRequest = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * MessageReadRequest chatId.
         * @member {string} chatId
         * @memberof chat.MessageReadRequest
         * @instance
         */
        MessageReadRequest.prototype.chatId = "";

        /**
         * MessageReadRequest messageId.
         * @member {string} messageId
         * @memberof chat.MessageReadRequest
         * @instance
         */
        MessageReadRequest.prototype.messageId = "";

        /**
         * Creates a new MessageReadRequest instance using the specified properties.
         * @function create
         * @memberof chat.MessageReadRequest
         * @static
         * @param {chat.MessageReadRequest.$Properties=} [properties] Properties to set
         * @returns {chat.MessageReadRequest} MessageReadRequest instance
         * @type {{
         *   (properties: chat.MessageReadRequest.$Shape): chat.MessageReadRequest & chat.MessageReadRequest.$Shape;
         *   (properties?: chat.MessageReadRequest.$Properties): chat.MessageReadRequest;
         * }}
         */
        MessageReadRequest.create = function(properties) {
            return new MessageReadRequest(properties);
        };

        /**
         * Encodes the specified MessageReadRequest message. Does not implicitly {@link chat.MessageReadRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.MessageReadRequest
         * @static
         * @param {chat.MessageReadRequest.$Properties} message MessageReadRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageReadRequest.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.messageId != null && $Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageId);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified MessageReadRequest message, length delimited. Does not implicitly {@link chat.MessageReadRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MessageReadRequest
         * @static
         * @param {chat.MessageReadRequest.$Properties} message MessageReadRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageReadRequest.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a MessageReadRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MessageReadRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MessageReadRequest & chat.MessageReadRequest.$Shape} MessageReadRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageReadRequest.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.MessageReadRequest(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.chatId = value;
                        else
                            delete message.chatId;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.messageId = value;
                        else
                            delete message.messageId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a MessageReadRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MessageReadRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MessageReadRequest & chat.MessageReadRequest.$Shape} MessageReadRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageReadRequest.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageReadRequest message.
         * @function verify
         * @memberof chat.MessageReadRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageReadRequest.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageId != null && $Object.hasOwnProperty.call(message, "messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            return null;
        };

        /**
         * Creates a MessageReadRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MessageReadRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MessageReadRequest} MessageReadRequest
         */
        MessageReadRequest.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.MessageReadRequest)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.MessageReadRequest: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.MessageReadRequest();
            if (object.chatId != null)
                if (typeof object.chatId !== "string" || object.chatId.length)
                    message.chatId = $String(object.chatId);
            if (object.messageId != null)
                if (typeof object.messageId !== "string" || object.messageId.length)
                    message.messageId = $String(object.messageId);
            return message;
        };

        /**
         * Creates a plain object from a MessageReadRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MessageReadRequest
         * @static
         * @param {chat.MessageReadRequest} message MessageReadRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageReadRequest.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults) {
                object.chatId = "";
                object.messageId = "";
            }
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                object.chatId = message.chatId;
            if (message.messageId != null && $Object.hasOwnProperty.call(message, "messageId"))
                object.messageId = message.messageId;
            return object;
        };

        /**
         * Converts this MessageReadRequest to JSON.
         * @function toJSON
         * @memberof chat.MessageReadRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageReadRequest.prototype.toJSON = function() {
            return MessageReadRequest.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for MessageReadRequest
         * @function getTypeUrl
         * @memberof chat.MessageReadRequest
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        MessageReadRequest.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.MessageReadRequest";
        };

        return MessageReadRequest;
    })();

    /**
     * ErrorCode enum.
     * @name chat.ErrorCode
     * @enum {number}
     * @property {number} Unspecified=0 Unspecified value
     * @property {number} Unauthenticated=1 Unauthenticated value
     * @property {number} Unauthorized=2 Unauthorized value
     * @property {number} InvalidParams=3 InvalidParams value
     */
    chat.ErrorCode = (function() {
        var valuesById = {}, values = $Object.create(valuesById);
        values[valuesById[0] = "Unspecified"] = 0;
        values[valuesById[1] = "Unauthenticated"] = 1;
        values[valuesById[2] = "Unauthorized"] = 2;
        values[valuesById[3] = "InvalidParams"] = 3;
        return values;
    })();

    chat.Error = (function() {

        /**
         * Properties of an Error.
         * @typedef {Object} chat.Error.$Properties
         * @property {chat.ErrorCode|null} [code] Error code
         * @property {string|null} [message] Error message
         * @property {string|null} [clientMessageId] Error clientMessageId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an Error.
         * @memberof chat
         * @interface IError
         * @augments chat.Error.$Properties
         * @deprecated Use chat.Error.$Properties instead.
         */

        /**
         * Shape of an Error.
         * @typedef {chat.Error.$Properties} chat.Error.$Shape
         */

        /**
         * Constructs a new Error.
         * @memberof chat
         * @classdesc Represents an Error.
         * @constructor
         * @param {chat.Error.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var Error = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Error code.
         * @member {chat.ErrorCode} code
         * @memberof chat.Error
         * @instance
         */
        Error.prototype.code = 0;

        /**
         * Error message.
         * @member {string} message
         * @memberof chat.Error
         * @instance
         */
        Error.prototype.message = "";

        /**
         * Error clientMessageId.
         * @member {string} clientMessageId
         * @memberof chat.Error
         * @instance
         */
        Error.prototype.clientMessageId = "";

        /**
         * Creates a new Error instance using the specified properties.
         * @function create
         * @memberof chat.Error
         * @static
         * @param {chat.Error.$Properties=} [properties] Properties to set
         * @returns {chat.Error} Error instance
         * @type {{
         *   (properties: chat.Error.$Shape): chat.Error & chat.Error.$Shape;
         *   (properties?: chat.Error.$Properties): chat.Error;
         * }}
         */
        Error.create = function(properties) {
            return new Error(properties);
        };

        /**
         * Encodes the specified Error message. Does not implicitly {@link chat.Error.verify|verify} messages.
         * @function encode
         * @memberof chat.Error
         * @static
         * @param {chat.Error.$Properties} message Error message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.code != null && $Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.message != null && $Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.clientMessageId != null && $Object.hasOwnProperty.call(message, "clientMessageId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.clientMessageId);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Error message, length delimited. Does not implicitly {@link chat.Error.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Error
         * @static
         * @param {chat.Error.$Properties} message Error message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an Error message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Error & chat.Error.$Shape} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.Error(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.code = value;
                        else
                            delete message.code;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.message = value;
                        else
                            delete message.message;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.clientMessageId = value;
                        else
                            delete message.clientMessageId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes an Error message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Error & chat.Error.$Shape} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Error message.
         * @function verify
         * @memberof chat.Error
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Error.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.code != null && $Object.hasOwnProperty.call(message, "code"))
                switch (message.code) {
                default:
                    return "code: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.message != null && $Object.hasOwnProperty.call(message, "message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.clientMessageId != null && $Object.hasOwnProperty.call(message, "clientMessageId"))
                if (!$util.isString(message.clientMessageId))
                    return "clientMessageId: string expected";
            return null;
        };

        /**
         * Creates an Error message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Error
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Error} Error
         */
        Error.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.Error)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.Error: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.Error();
            if (object.code !== 0 && (typeof object.code !== "string" || $root.chat.ErrorCode[object.code] !== 0))
                switch (object.code) {
                default:
                    if (typeof object.code === "number") {
                        message.code = object.code;
                        break;
                    }
                    break;
                case "Unspecified":
                case 0:
                    message.code = 0;
                    break;
                case "Unauthenticated":
                case 1:
                    message.code = 1;
                    break;
                case "Unauthorized":
                case 2:
                    message.code = 2;
                    break;
                case "InvalidParams":
                case 3:
                    message.code = 3;
                    break;
                }
            if (object.message != null)
                if (typeof object.message !== "string" || object.message.length)
                    message.message = $String(object.message);
            if (object.clientMessageId != null)
                if (typeof object.clientMessageId !== "string" || object.clientMessageId.length)
                    message.clientMessageId = $String(object.clientMessageId);
            return message;
        };

        /**
         * Creates a plain object from an Error message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Error
         * @static
         * @param {chat.Error} message Error
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Error.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults) {
                object.code = options.enums === $String ? "Unspecified" : 0;
                object.message = "";
                object.clientMessageId = "";
            }
            if (message.code != null && $Object.hasOwnProperty.call(message, "code"))
                object.code = options.enums === $String ? $root.chat.ErrorCode[message.code] === $undefined ? message.code : $root.chat.ErrorCode[message.code] : message.code;
            if (message.message != null && $Object.hasOwnProperty.call(message, "message"))
                object.message = message.message;
            if (message.clientMessageId != null && $Object.hasOwnProperty.call(message, "clientMessageId"))
                object.clientMessageId = message.clientMessageId;
            return object;
        };

        /**
         * Converts this Error to JSON.
         * @function toJSON
         * @memberof chat.Error
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Error.prototype.toJSON = function() {
            return Error.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Error
         * @function getTypeUrl
         * @memberof chat.Error
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Error.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.Error";
        };

        return Error;
    })();

    chat.EventRef = (function() {

        /**
         * Properties of an EventRef.
         * @typedef {Object} chat.EventRef.$Properties
         * @property {string|null} [id] EventRef id
         * @property {string|null} [thumbnailId] EventRef thumbnailId
         * @property {string|null} [color] EventRef color
         * @property {string|null} [title] EventRef title
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an EventRef.
         * @memberof chat
         * @interface IEventRef
         * @augments chat.EventRef.$Properties
         * @deprecated Use chat.EventRef.$Properties instead.
         */

        /**
         * Shape of an EventRef.
         * @typedef {chat.EventRef.$Properties} chat.EventRef.$Shape
         */

        /**
         * Constructs a new EventRef.
         * @memberof chat
         * @classdesc Represents an EventRef.
         * @constructor
         * @param {chat.EventRef.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var EventRef = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * EventRef id.
         * @member {string} id
         * @memberof chat.EventRef
         * @instance
         */
        EventRef.prototype.id = "";

        /**
         * EventRef thumbnailId.
         * @member {string} thumbnailId
         * @memberof chat.EventRef
         * @instance
         */
        EventRef.prototype.thumbnailId = "";

        /**
         * EventRef color.
         * @member {string} color
         * @memberof chat.EventRef
         * @instance
         */
        EventRef.prototype.color = "";

        /**
         * EventRef title.
         * @member {string} title
         * @memberof chat.EventRef
         * @instance
         */
        EventRef.prototype.title = "";

        /**
         * Creates a new EventRef instance using the specified properties.
         * @function create
         * @memberof chat.EventRef
         * @static
         * @param {chat.EventRef.$Properties=} [properties] Properties to set
         * @returns {chat.EventRef} EventRef instance
         * @type {{
         *   (properties: chat.EventRef.$Shape): chat.EventRef & chat.EventRef.$Shape;
         *   (properties?: chat.EventRef.$Properties): chat.EventRef;
         * }}
         */
        EventRef.create = function(properties) {
            return new EventRef(properties);
        };

        /**
         * Encodes the specified EventRef message. Does not implicitly {@link chat.EventRef.verify|verify} messages.
         * @function encode
         * @memberof chat.EventRef
         * @static
         * @param {chat.EventRef.$Properties} message EventRef message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventRef.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.thumbnailId != null && $Object.hasOwnProperty.call(message, "thumbnailId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.thumbnailId);
            if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.color);
            if (message.title != null && $Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.title);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified EventRef message, length delimited. Does not implicitly {@link chat.EventRef.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.EventRef
         * @static
         * @param {chat.EventRef.$Properties} message EventRef message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventRef.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an EventRef message from the specified reader or buffer.
         * @function decode
         * @memberof chat.EventRef
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.EventRef & chat.EventRef.$Shape} EventRef
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventRef.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.EventRef(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.thumbnailId = value;
                        else
                            delete message.thumbnailId;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.color = value;
                        else
                            delete message.color;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.title = value;
                        else
                            delete message.title;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes an EventRef message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.EventRef
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.EventRef & chat.EventRef.$Shape} EventRef
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventRef.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EventRef message.
         * @function verify
         * @memberof chat.EventRef
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EventRef.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.thumbnailId != null && $Object.hasOwnProperty.call(message, "thumbnailId"))
                if (!$util.isString(message.thumbnailId))
                    return "thumbnailId: string expected";
            if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
                if (!$util.isString(message.color))
                    return "color: string expected";
            if (message.title != null && $Object.hasOwnProperty.call(message, "title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            return null;
        };

        /**
         * Creates an EventRef message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.EventRef
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.EventRef} EventRef
         */
        EventRef.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.EventRef)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.EventRef: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.EventRef();
            if (object.id != null)
                if (typeof object.id !== "string" || object.id.length)
                    message.id = $String(object.id);
            if (object.thumbnailId != null)
                if (typeof object.thumbnailId !== "string" || object.thumbnailId.length)
                    message.thumbnailId = $String(object.thumbnailId);
            if (object.color != null)
                if (typeof object.color !== "string" || object.color.length)
                    message.color = $String(object.color);
            if (object.title != null)
                if (typeof object.title !== "string" || object.title.length)
                    message.title = $String(object.title);
            return message;
        };

        /**
         * Creates a plain object from an EventRef message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.EventRef
         * @static
         * @param {chat.EventRef} message EventRef
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EventRef.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.thumbnailId = "";
                object.color = "";
                object.title = "";
            }
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                object.id = message.id;
            if (message.thumbnailId != null && $Object.hasOwnProperty.call(message, "thumbnailId"))
                object.thumbnailId = message.thumbnailId;
            if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
                object.color = message.color;
            if (message.title != null && $Object.hasOwnProperty.call(message, "title"))
                object.title = message.title;
            return object;
        };

        /**
         * Converts this EventRef to JSON.
         * @function toJSON
         * @memberof chat.EventRef
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EventRef.prototype.toJSON = function() {
            return EventRef.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for EventRef
         * @function getTypeUrl
         * @memberof chat.EventRef
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        EventRef.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.EventRef";
        };

        return EventRef;
    })();

    chat.GroupRef = (function() {

        /**
         * Properties of a GroupRef.
         * @typedef {Object} chat.GroupRef.$Properties
         * @property {string|null} [id] GroupRef id
         * @property {string|null} [thumbnailId] GroupRef thumbnailId
         * @property {string|null} [color] GroupRef color
         * @property {string|null} [name] GroupRef name
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a GroupRef.
         * @memberof chat
         * @interface IGroupRef
         * @augments chat.GroupRef.$Properties
         * @deprecated Use chat.GroupRef.$Properties instead.
         */

        /**
         * Shape of a GroupRef.
         * @typedef {chat.GroupRef.$Properties} chat.GroupRef.$Shape
         */

        /**
         * Constructs a new GroupRef.
         * @memberof chat
         * @classdesc Represents a GroupRef.
         * @constructor
         * @param {chat.GroupRef.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var GroupRef = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * GroupRef id.
         * @member {string} id
         * @memberof chat.GroupRef
         * @instance
         */
        GroupRef.prototype.id = "";

        /**
         * GroupRef thumbnailId.
         * @member {string} thumbnailId
         * @memberof chat.GroupRef
         * @instance
         */
        GroupRef.prototype.thumbnailId = "";

        /**
         * GroupRef color.
         * @member {string} color
         * @memberof chat.GroupRef
         * @instance
         */
        GroupRef.prototype.color = "";

        /**
         * GroupRef name.
         * @member {string} name
         * @memberof chat.GroupRef
         * @instance
         */
        GroupRef.prototype.name = "";

        /**
         * Creates a new GroupRef instance using the specified properties.
         * @function create
         * @memberof chat.GroupRef
         * @static
         * @param {chat.GroupRef.$Properties=} [properties] Properties to set
         * @returns {chat.GroupRef} GroupRef instance
         * @type {{
         *   (properties: chat.GroupRef.$Shape): chat.GroupRef & chat.GroupRef.$Shape;
         *   (properties?: chat.GroupRef.$Properties): chat.GroupRef;
         * }}
         */
        GroupRef.create = function(properties) {
            return new GroupRef(properties);
        };

        /**
         * Encodes the specified GroupRef message. Does not implicitly {@link chat.GroupRef.verify|verify} messages.
         * @function encode
         * @memberof chat.GroupRef
         * @static
         * @param {chat.GroupRef.$Properties} message GroupRef message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GroupRef.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.thumbnailId != null && $Object.hasOwnProperty.call(message, "thumbnailId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.thumbnailId);
            if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.color);
            if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified GroupRef message, length delimited. Does not implicitly {@link chat.GroupRef.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.GroupRef
         * @static
         * @param {chat.GroupRef.$Properties} message GroupRef message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GroupRef.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a GroupRef message from the specified reader or buffer.
         * @function decode
         * @memberof chat.GroupRef
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.GroupRef & chat.GroupRef.$Shape} GroupRef
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GroupRef.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.GroupRef(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.thumbnailId = value;
                        else
                            delete message.thumbnailId;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.color = value;
                        else
                            delete message.color;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.name = value;
                        else
                            delete message.name;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a GroupRef message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.GroupRef
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.GroupRef & chat.GroupRef.$Shape} GroupRef
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GroupRef.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GroupRef message.
         * @function verify
         * @memberof chat.GroupRef
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GroupRef.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.thumbnailId != null && $Object.hasOwnProperty.call(message, "thumbnailId"))
                if (!$util.isString(message.thumbnailId))
                    return "thumbnailId: string expected";
            if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
                if (!$util.isString(message.color))
                    return "color: string expected";
            if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a GroupRef message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.GroupRef
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.GroupRef} GroupRef
         */
        GroupRef.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.GroupRef)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.GroupRef: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.GroupRef();
            if (object.id != null)
                if (typeof object.id !== "string" || object.id.length)
                    message.id = $String(object.id);
            if (object.thumbnailId != null)
                if (typeof object.thumbnailId !== "string" || object.thumbnailId.length)
                    message.thumbnailId = $String(object.thumbnailId);
            if (object.color != null)
                if (typeof object.color !== "string" || object.color.length)
                    message.color = $String(object.color);
            if (object.name != null)
                if (typeof object.name !== "string" || object.name.length)
                    message.name = $String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a GroupRef message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.GroupRef
         * @static
         * @param {chat.GroupRef} message GroupRef
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GroupRef.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.thumbnailId = "";
                object.color = "";
                object.name = "";
            }
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                object.id = message.id;
            if (message.thumbnailId != null && $Object.hasOwnProperty.call(message, "thumbnailId"))
                object.thumbnailId = message.thumbnailId;
            if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
                object.color = message.color;
            if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this GroupRef to JSON.
         * @function toJSON
         * @memberof chat.GroupRef
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GroupRef.prototype.toJSON = function() {
            return GroupRef.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for GroupRef
         * @function getTypeUrl
         * @memberof chat.GroupRef
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        GroupRef.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.GroupRef";
        };

        return GroupRef;
    })();

    chat.Chat = (function() {

        /**
         * Properties of a Chat.
         * @typedef {Object} chat.Chat.$Properties
         * @property {string|null} [id] Chat id
         * @property {string|null} [name] Chat name
         * @property {chat.Timestamp.$Properties|null} [lastActivity] Chat lastActivity
         * @property {chat.Timestamp.$Properties|null} [lockedAt] Chat lockedAt
         * @property {chat.Timestamp.$Properties|null} [deletedAt] Chat deletedAt
         * @property {boolean|null} [hidden] Chat hidden
         * @property {boolean|null} [muted] Chat muted
         * @property {string|null} [lastReadMessage] Chat lastReadMessage
         * @property {Array.<chat.Avatar.$Properties>|null} [participants] Chat participants
         * @property {number|null} [priority] Chat priority
         * @property {chat.EventRef.$Properties|null} [event] Chat event
         * @property {chat.GroupRef.$Properties|null} [group] Chat group
         * @property {chat.Avatar.$Properties|null} [user] Chat user
         * @property {boolean|null} [canModerate] Chat canModerate
         * @property {boolean|null} [canPost] Chat canPost
         * @property {"event"|"group"|"user"} [attachedTo] Chat attachedTo
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Chat.
         * @memberof chat
         * @interface IChat
         * @augments chat.Chat.$Properties
         * @deprecated Use chat.Chat.$Properties instead.
         */

        /**
         * Narrowed shape of a Chat.
         * @typedef {{
         *   id?: string|null;
         *   name?: string|null;
         *   lastActivity?: chat.Timestamp.$Shape|null;
         *   lockedAt?: chat.Timestamp.$Shape|null;
         *   deletedAt?: chat.Timestamp.$Shape|null;
         *   hidden?: boolean|null;
         *   muted?: boolean|null;
         *   lastReadMessage?: string|null;
         *   participants?: Array.<chat.Avatar.$Shape>|null;
         *   priority?: number|null;
         *   event?: chat.EventRef.$Shape|null;
         *   group?: chat.GroupRef.$Shape|null;
         *   user?: chat.Avatar.$Shape|null;
         *   canModerate?: boolean|null;
         *   canPost?: boolean|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ attachedTo?: undefined; event?: null; group?: null; user?: null }|{ attachedTo?: "event"; event: chat.EventRef.$Shape; group?: null; user?: null }|{ attachedTo?: "group"; event?: null; group: chat.GroupRef.$Shape; user?: null }|{ attachedTo?: "user"; event?: null; group?: null; user: chat.Avatar.$Shape })
         * )} chat.Chat.$Shape
         */

        /**
         * Constructs a new Chat.
         * @memberof chat
         * @classdesc Represents a Chat.
         * @constructor
         * @param {chat.Chat.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var Chat = function (properties) {
            this.participants = [];
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Chat id.
         * @member {string} id
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.id = "";

        /**
         * Chat name.
         * @member {string} name
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.name = "";

        /**
         * Chat lastActivity.
         * @member {chat.Timestamp.$Properties|null|undefined} lastActivity
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.lastActivity = null;

        /**
         * Chat lockedAt.
         * @member {chat.Timestamp.$Properties|null|undefined} lockedAt
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.lockedAt = null;

        /**
         * Chat deletedAt.
         * @member {chat.Timestamp.$Properties|null|undefined} deletedAt
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.deletedAt = null;

        /**
         * Chat hidden.
         * @member {boolean} hidden
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.hidden = false;

        /**
         * Chat muted.
         * @member {boolean} muted
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.muted = false;

        /**
         * Chat lastReadMessage.
         * @member {string} lastReadMessage
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.lastReadMessage = "";

        /**
         * Chat participants.
         * @member {Array.<chat.Avatar.$Properties>} participants
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.participants = $util.emptyArray;

        /**
         * Chat priority.
         * @member {number} priority
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.priority = 0;

        /**
         * Chat event.
         * @member {chat.EventRef.$Properties|null|undefined} event
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.event = null;

        /**
         * Chat group.
         * @member {chat.GroupRef.$Properties|null|undefined} group
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.group = null;

        /**
         * Chat user.
         * @member {chat.Avatar.$Properties|null|undefined} user
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.user = null;

        /**
         * Chat canModerate.
         * @member {boolean} canModerate
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.canModerate = false;

        /**
         * Chat canPost.
         * @member {boolean} canPost
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.canPost = false;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * Chat attachedTo.
         * @member {"event"|"group"|"user"|undefined} attachedTo
         * @memberof chat.Chat
         * @instance
         */
        $Object.defineProperty(Chat.prototype, "attachedTo", {
            get: $util.oneOfGetter($oneOfFields = ["event", "group", "user"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Chat instance using the specified properties.
         * @function create
         * @memberof chat.Chat
         * @static
         * @param {chat.Chat.$Properties=} [properties] Properties to set
         * @returns {chat.Chat} Chat instance
         * @type {{
         *   (properties: chat.Chat.$Shape): chat.Chat & chat.Chat.$Shape;
         *   (properties?: chat.Chat.$Properties): chat.Chat;
         * }}
         */
        Chat.create = function(properties) {
            return new Chat(properties);
        };

        /**
         * Encodes the specified Chat message. Does not implicitly {@link chat.Chat.verify|verify} messages.
         * @function encode
         * @memberof chat.Chat
         * @static
         * @param {chat.Chat.$Properties} message Chat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Chat.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.lastActivity != null && $Object.hasOwnProperty.call(message, "lastActivity"))
                $root.chat.Timestamp.encode(message.lastActivity, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
            if (message.lockedAt != null && $Object.hasOwnProperty.call(message, "lockedAt"))
                $root.chat.Timestamp.encode(message.lockedAt, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.deletedAt != null && $Object.hasOwnProperty.call(message, "deletedAt"))
                $root.chat.Timestamp.encode(message.deletedAt, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.hidden != null && $Object.hasOwnProperty.call(message, "hidden"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.hidden);
            if (message.muted != null && $Object.hasOwnProperty.call(message, "muted"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.muted);
            if (message.lastReadMessage != null && $Object.hasOwnProperty.call(message, "lastReadMessage"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.lastReadMessage);
            if (message.participants != null && message.participants.length)
                for (var i = 0; i < message.participants.length; ++i)
                    $root.chat.Avatar.encode(message.participants[i], writer.uint32(/* id 9, wireType 2 =*/74).fork(), _depth + 1).ldelim();
            if (message.priority != null && $Object.hasOwnProperty.call(message, "priority"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.priority);
            if (message.event != null && $Object.hasOwnProperty.call(message, "event"))
                $root.chat.EventRef.encode(message.event, writer.uint32(/* id 11, wireType 2 =*/90).fork(), _depth + 1).ldelim();
            if (message.group != null && $Object.hasOwnProperty.call(message, "group"))
                $root.chat.GroupRef.encode(message.group, writer.uint32(/* id 12, wireType 2 =*/98).fork(), _depth + 1).ldelim();
            if (message.user != null && $Object.hasOwnProperty.call(message, "user"))
                $root.chat.Avatar.encode(message.user, writer.uint32(/* id 13, wireType 2 =*/106).fork(), _depth + 1).ldelim();
            if (message.canModerate != null && $Object.hasOwnProperty.call(message, "canModerate"))
                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.canModerate);
            if (message.canPost != null && $Object.hasOwnProperty.call(message, "canPost"))
                writer.uint32(/* id 15, wireType 0 =*/120).bool(message.canPost);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Chat message, length delimited. Does not implicitly {@link chat.Chat.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Chat
         * @static
         * @param {chat.Chat.$Properties} message Chat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Chat.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Chat message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Chat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Chat & chat.Chat.$Shape} Chat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Chat.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.Chat(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.name = value;
                        else
                            delete message.name;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.lastActivity = $root.chat.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.lastActivity);
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.lockedAt = $root.chat.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.lockedAt);
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        message.deletedAt = $root.chat.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.deletedAt);
                        continue;
                    }
                case 6: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.hidden = value;
                        else
                            delete message.hidden;
                        continue;
                    }
                case 7: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.muted = value;
                        else
                            delete message.muted;
                        continue;
                    }
                case 8: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.lastReadMessage = value;
                        else
                            delete message.lastReadMessage;
                        continue;
                    }
                case 9: {
                        if (wireType !== 2)
                            break;
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.chat.Avatar.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                case 10: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.priority = value;
                        else
                            delete message.priority;
                        continue;
                    }
                case 11: {
                        if (wireType !== 2)
                            break;
                        message.event = $root.chat.EventRef.decode(reader, reader.uint32(), $undefined, _depth + 1, message.event);
                        message.attachedTo = "event";
                        continue;
                    }
                case 12: {
                        if (wireType !== 2)
                            break;
                        message.group = $root.chat.GroupRef.decode(reader, reader.uint32(), $undefined, _depth + 1, message.group);
                        message.attachedTo = "group";
                        continue;
                    }
                case 13: {
                        if (wireType !== 2)
                            break;
                        message.user = $root.chat.Avatar.decode(reader, reader.uint32(), $undefined, _depth + 1, message.user);
                        message.attachedTo = "user";
                        continue;
                    }
                case 14: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.canModerate = value;
                        else
                            delete message.canModerate;
                        continue;
                    }
                case 15: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.canPost = value;
                        else
                            delete message.canPost;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a Chat message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Chat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Chat & chat.Chat.$Shape} Chat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Chat.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Chat message.
         * @function verify
         * @memberof chat.Chat
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Chat.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            var properties = {};
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.lastActivity != null && $Object.hasOwnProperty.call(message, "lastActivity")) {
                var error = $root.chat.Timestamp.verify(message.lastActivity, _depth + 1);
                if (error)
                    return "lastActivity." + error;
            }
            if (message.lockedAt != null && $Object.hasOwnProperty.call(message, "lockedAt")) {
                var error = $root.chat.Timestamp.verify(message.lockedAt, _depth + 1);
                if (error)
                    return "lockedAt." + error;
            }
            if (message.deletedAt != null && $Object.hasOwnProperty.call(message, "deletedAt")) {
                var error = $root.chat.Timestamp.verify(message.deletedAt, _depth + 1);
                if (error)
                    return "deletedAt." + error;
            }
            if (message.hidden != null && $Object.hasOwnProperty.call(message, "hidden"))
                if (typeof message.hidden !== "boolean")
                    return "hidden: boolean expected";
            if (message.muted != null && $Object.hasOwnProperty.call(message, "muted"))
                if (typeof message.muted !== "boolean")
                    return "muted: boolean expected";
            if (message.lastReadMessage != null && $Object.hasOwnProperty.call(message, "lastReadMessage"))
                if (!$util.isString(message.lastReadMessage))
                    return "lastReadMessage: string expected";
            if (message.participants != null && $Object.hasOwnProperty.call(message, "participants")) {
                if (!$Array.isArray(message.participants))
                    return "participants: array expected";
                for (var i = 0; i < message.participants.length; ++i) {
                    var error = $root.chat.Avatar.verify(message.participants[i], _depth + 1);
                    if (error)
                        return "participants." + error;
                }
            }
            if (message.priority != null && $Object.hasOwnProperty.call(message, "priority"))
                if (!$util.isInteger(message.priority))
                    return "priority: integer expected";
            if (message.event != null && $Object.hasOwnProperty.call(message, "event")) {
                properties.attachedTo = 1;
                {
                    var error = $root.chat.EventRef.verify(message.event, _depth + 1);
                    if (error)
                        return "event." + error;
                }
            }
            if (message.group != null && $Object.hasOwnProperty.call(message, "group")) {
                if (properties.attachedTo === 1)
                    return "attachedTo: multiple values";
                properties.attachedTo = 1;
                {
                    var error = $root.chat.GroupRef.verify(message.group, _depth + 1);
                    if (error)
                        return "group." + error;
                }
            }
            if (message.user != null && $Object.hasOwnProperty.call(message, "user")) {
                if (properties.attachedTo === 1)
                    return "attachedTo: multiple values";
                properties.attachedTo = 1;
                {
                    var error = $root.chat.Avatar.verify(message.user, _depth + 1);
                    if (error)
                        return "user." + error;
                }
            }
            if (message.canModerate != null && $Object.hasOwnProperty.call(message, "canModerate"))
                if (typeof message.canModerate !== "boolean")
                    return "canModerate: boolean expected";
            if (message.canPost != null && $Object.hasOwnProperty.call(message, "canPost"))
                if (typeof message.canPost !== "boolean")
                    return "canPost: boolean expected";
            return null;
        };

        /**
         * Creates a Chat message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Chat
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Chat} Chat
         */
        Chat.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.Chat)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.Chat: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.Chat();
            if (object.id != null)
                if (typeof object.id !== "string" || object.id.length)
                    message.id = $String(object.id);
            if (object.name != null)
                if (typeof object.name !== "string" || object.name.length)
                    message.name = $String(object.name);
            if (object.lastActivity != null) {
                if (!$util.isObject(object.lastActivity))
                    throw $TypeError(".chat.Chat.lastActivity: object expected");
                message.lastActivity = $root.chat.Timestamp.fromObject(object.lastActivity, _depth + 1);
            }
            if (object.lockedAt != null) {
                if (!$util.isObject(object.lockedAt))
                    throw $TypeError(".chat.Chat.lockedAt: object expected");
                message.lockedAt = $root.chat.Timestamp.fromObject(object.lockedAt, _depth + 1);
            }
            if (object.deletedAt != null) {
                if (!$util.isObject(object.deletedAt))
                    throw $TypeError(".chat.Chat.deletedAt: object expected");
                message.deletedAt = $root.chat.Timestamp.fromObject(object.deletedAt, _depth + 1);
            }
            if (object.hidden != null)
                if (object.hidden)
                    message.hidden = $Boolean(object.hidden);
            if (object.muted != null)
                if (object.muted)
                    message.muted = $Boolean(object.muted);
            if (object.lastReadMessage != null)
                if (typeof object.lastReadMessage !== "string" || object.lastReadMessage.length)
                    message.lastReadMessage = $String(object.lastReadMessage);
            if (object.participants) {
                if (!$Array.isArray(object.participants))
                    throw $TypeError(".chat.Chat.participants: array expected");
                message.participants = $Array(object.participants.length);
                for (var i = 0; i < object.participants.length; ++i) {
                    if (!$util.isObject(object.participants[i]))
                        throw $TypeError(".chat.Chat.participants: object expected");
                    message.participants[i] = $root.chat.Avatar.fromObject(object.participants[i], _depth + 1);
                }
            }
            if (object.priority != null)
                if ($Number(object.priority) !== 0)
                    message.priority = object.priority | 0;
            if (object.event != null) {
                if (!$util.isObject(object.event))
                    throw $TypeError(".chat.Chat.event: object expected");
                message.event = $root.chat.EventRef.fromObject(object.event, _depth + 1);
            }
            if (object.group != null) {
                if (!$util.isObject(object.group))
                    throw $TypeError(".chat.Chat.group: object expected");
                message.group = $root.chat.GroupRef.fromObject(object.group, _depth + 1);
            }
            if (object.user != null) {
                if (!$util.isObject(object.user))
                    throw $TypeError(".chat.Chat.user: object expected");
                message.user = $root.chat.Avatar.fromObject(object.user, _depth + 1);
            }
            if (object.canModerate != null)
                if (object.canModerate)
                    message.canModerate = $Boolean(object.canModerate);
            if (object.canPost != null)
                if (object.canPost)
                    message.canPost = $Boolean(object.canPost);
            return message;
        };

        /**
         * Creates a plain object from a Chat message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Chat
         * @static
         * @param {chat.Chat} message Chat
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Chat.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.arrays || options.defaults)
                object.participants = [];
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.lastActivity = null;
                object.lockedAt = null;
                object.deletedAt = null;
                object.hidden = false;
                object.muted = false;
                object.lastReadMessage = "";
                object.priority = 0;
                object.canModerate = false;
                object.canPost = false;
            }
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                object.id = message.id;
            if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                object.name = message.name;
            if (message.lastActivity != null && $Object.hasOwnProperty.call(message, "lastActivity"))
                object.lastActivity = $root.chat.Timestamp.toObject(message.lastActivity, options, _depth + 1);
            if (message.lockedAt != null && $Object.hasOwnProperty.call(message, "lockedAt"))
                object.lockedAt = $root.chat.Timestamp.toObject(message.lockedAt, options, _depth + 1);
            if (message.deletedAt != null && $Object.hasOwnProperty.call(message, "deletedAt"))
                object.deletedAt = $root.chat.Timestamp.toObject(message.deletedAt, options, _depth + 1);
            if (message.hidden != null && $Object.hasOwnProperty.call(message, "hidden"))
                object.hidden = message.hidden;
            if (message.muted != null && $Object.hasOwnProperty.call(message, "muted"))
                object.muted = message.muted;
            if (message.lastReadMessage != null && $Object.hasOwnProperty.call(message, "lastReadMessage"))
                object.lastReadMessage = message.lastReadMessage;
            if (message.participants && message.participants.length) {
                object.participants = $Array(message.participants.length);
                for (var j = 0; j < message.participants.length; ++j)
                    object.participants[j] = $root.chat.Avatar.toObject(message.participants[j], options, _depth + 1);
            }
            if (message.priority != null && $Object.hasOwnProperty.call(message, "priority"))
                object.priority = message.priority;
            if (message.event != null && $Object.hasOwnProperty.call(message, "event")) {
                object.event = $root.chat.EventRef.toObject(message.event, options, _depth + 1);
                if (options.oneofs)
                    object.attachedTo = "event";
            }
            if (message.group != null && $Object.hasOwnProperty.call(message, "group")) {
                object.group = $root.chat.GroupRef.toObject(message.group, options, _depth + 1);
                if (options.oneofs)
                    object.attachedTo = "group";
            }
            if (message.user != null && $Object.hasOwnProperty.call(message, "user")) {
                object.user = $root.chat.Avatar.toObject(message.user, options, _depth + 1);
                if (options.oneofs)
                    object.attachedTo = "user";
            }
            if (message.canModerate != null && $Object.hasOwnProperty.call(message, "canModerate"))
                object.canModerate = message.canModerate;
            if (message.canPost != null && $Object.hasOwnProperty.call(message, "canPost"))
                object.canPost = message.canPost;
            return object;
        };

        /**
         * Converts this Chat to JSON.
         * @function toJSON
         * @memberof chat.Chat
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Chat.prototype.toJSON = function() {
            return Chat.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Chat
         * @function getTypeUrl
         * @memberof chat.Chat
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Chat.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.Chat";
        };

        return Chat;
    })();

    chat.Avatar = (function() {

        /**
         * Properties of an Avatar.
         * @typedef {Object} chat.Avatar.$Properties
         * @property {number|null} [id] Avatar id
         * @property {string|null} [username] Avatar username
         * @property {string|null} [gecos] Avatar gecos
         * @property {string|null} [avatarUrl] Avatar avatarUrl
         * @property {string|null} [color] Avatar color
         * @property {string|null} [contrastColor] Avatar contrastColor
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an Avatar.
         * @memberof chat
         * @interface IAvatar
         * @augments chat.Avatar.$Properties
         * @deprecated Use chat.Avatar.$Properties instead.
         */

        /**
         * Shape of an Avatar.
         * @typedef {chat.Avatar.$Properties} chat.Avatar.$Shape
         */

        /**
         * Constructs a new Avatar.
         * @memberof chat
         * @classdesc Represents an Avatar.
         * @constructor
         * @param {chat.Avatar.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var Avatar = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Avatar id.
         * @member {number} id
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.id = 0;

        /**
         * Avatar username.
         * @member {string} username
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.username = "";

        /**
         * Avatar gecos.
         * @member {string} gecos
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.gecos = "";

        /**
         * Avatar avatarUrl.
         * @member {string} avatarUrl
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.avatarUrl = "";

        /**
         * Avatar color.
         * @member {string} color
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.color = "";

        /**
         * Avatar contrastColor.
         * @member {string} contrastColor
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.contrastColor = "";

        /**
         * Creates a new Avatar instance using the specified properties.
         * @function create
         * @memberof chat.Avatar
         * @static
         * @param {chat.Avatar.$Properties=} [properties] Properties to set
         * @returns {chat.Avatar} Avatar instance
         * @type {{
         *   (properties: chat.Avatar.$Shape): chat.Avatar & chat.Avatar.$Shape;
         *   (properties?: chat.Avatar.$Properties): chat.Avatar;
         * }}
         */
        Avatar.create = function(properties) {
            return new Avatar(properties);
        };

        /**
         * Encodes the specified Avatar message. Does not implicitly {@link chat.Avatar.verify|verify} messages.
         * @function encode
         * @memberof chat.Avatar
         * @static
         * @param {chat.Avatar.$Properties} message Avatar message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Avatar.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
            if (message.username != null && $Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
            if (message.gecos != null && $Object.hasOwnProperty.call(message, "gecos"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.gecos);
            if (message.avatarUrl != null && $Object.hasOwnProperty.call(message, "avatarUrl"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.avatarUrl);
            if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.color);
            if (message.contrastColor != null && $Object.hasOwnProperty.call(message, "contrastColor"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.contrastColor);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Avatar message, length delimited. Does not implicitly {@link chat.Avatar.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Avatar
         * @static
         * @param {chat.Avatar.$Properties} message Avatar message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Avatar.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an Avatar message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Avatar
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Avatar & chat.Avatar.$Shape} Avatar
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Avatar.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.Avatar(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.username = value;
                        else
                            delete message.username;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.gecos = value;
                        else
                            delete message.gecos;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.avatarUrl = value;
                        else
                            delete message.avatarUrl;
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.color = value;
                        else
                            delete message.color;
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.contrastColor = value;
                        else
                            delete message.contrastColor;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes an Avatar message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Avatar
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Avatar & chat.Avatar.$Shape} Avatar
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Avatar.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Avatar message.
         * @function verify
         * @memberof chat.Avatar
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Avatar.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
            if (message.username != null && $Object.hasOwnProperty.call(message, "username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.gecos != null && $Object.hasOwnProperty.call(message, "gecos"))
                if (!$util.isString(message.gecos))
                    return "gecos: string expected";
            if (message.avatarUrl != null && $Object.hasOwnProperty.call(message, "avatarUrl"))
                if (!$util.isString(message.avatarUrl))
                    return "avatarUrl: string expected";
            if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
                if (!$util.isString(message.color))
                    return "color: string expected";
            if (message.contrastColor != null && $Object.hasOwnProperty.call(message, "contrastColor"))
                if (!$util.isString(message.contrastColor))
                    return "contrastColor: string expected";
            return null;
        };

        /**
         * Creates an Avatar message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Avatar
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Avatar} Avatar
         */
        Avatar.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.Avatar)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.Avatar: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.Avatar();
            if (object.id != null)
                if ($Number(object.id) !== 0)
                    message.id = object.id | 0;
            if (object.username != null)
                if (typeof object.username !== "string" || object.username.length)
                    message.username = $String(object.username);
            if (object.gecos != null)
                if (typeof object.gecos !== "string" || object.gecos.length)
                    message.gecos = $String(object.gecos);
            if (object.avatarUrl != null)
                if (typeof object.avatarUrl !== "string" || object.avatarUrl.length)
                    message.avatarUrl = $String(object.avatarUrl);
            if (object.color != null)
                if (typeof object.color !== "string" || object.color.length)
                    message.color = $String(object.color);
            if (object.contrastColor != null)
                if (typeof object.contrastColor !== "string" || object.contrastColor.length)
                    message.contrastColor = $String(object.contrastColor);
            return message;
        };

        /**
         * Creates a plain object from an Avatar message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Avatar
         * @static
         * @param {chat.Avatar} message Avatar
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Avatar.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults) {
                object.id = 0;
                object.username = "";
                object.gecos = "";
                object.avatarUrl = "";
                object.color = "";
                object.contrastColor = "";
            }
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                object.id = message.id;
            if (message.username != null && $Object.hasOwnProperty.call(message, "username"))
                object.username = message.username;
            if (message.gecos != null && $Object.hasOwnProperty.call(message, "gecos"))
                object.gecos = message.gecos;
            if (message.avatarUrl != null && $Object.hasOwnProperty.call(message, "avatarUrl"))
                object.avatarUrl = message.avatarUrl;
            if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
                object.color = message.color;
            if (message.contrastColor != null && $Object.hasOwnProperty.call(message, "contrastColor"))
                object.contrastColor = message.contrastColor;
            return object;
        };

        /**
         * Converts this Avatar to JSON.
         * @function toJSON
         * @memberof chat.Avatar
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Avatar.prototype.toJSON = function() {
            return Avatar.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Avatar
         * @function getTypeUrl
         * @memberof chat.Avatar
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Avatar.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.Avatar";
        };

        return Avatar;
    })();

    chat.Timestamp = (function() {

        /**
         * Properties of a Timestamp.
         * @typedef {Object} chat.Timestamp.$Properties
         * @property {number|Long|null} [unixMsec] Timestamp unixMsec
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Timestamp.
         * @memberof chat
         * @interface ITimestamp
         * @augments chat.Timestamp.$Properties
         * @deprecated Use chat.Timestamp.$Properties instead.
         */

        /**
         * Shape of a Timestamp.
         * @typedef {chat.Timestamp.$Properties} chat.Timestamp.$Shape
         */

        /**
         * Constructs a new Timestamp.
         * @memberof chat
         * @classdesc Represents a Timestamp.
         * @constructor
         * @param {chat.Timestamp.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var Timestamp = function (properties) {
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Timestamp unixMsec.
         * @member {number|Long} unixMsec
         * @memberof chat.Timestamp
         * @instance
         */
        Timestamp.prototype.unixMsec = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Timestamp instance using the specified properties.
         * @function create
         * @memberof chat.Timestamp
         * @static
         * @param {chat.Timestamp.$Properties=} [properties] Properties to set
         * @returns {chat.Timestamp} Timestamp instance
         * @type {{
         *   (properties: chat.Timestamp.$Shape): chat.Timestamp & chat.Timestamp.$Shape;
         *   (properties?: chat.Timestamp.$Properties): chat.Timestamp;
         * }}
         */
        Timestamp.create = function(properties) {
            return new Timestamp(properties);
        };

        /**
         * Encodes the specified Timestamp message. Does not implicitly {@link chat.Timestamp.verify|verify} messages.
         * @function encode
         * @memberof chat.Timestamp
         * @static
         * @param {chat.Timestamp.$Properties} message Timestamp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Timestamp.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.unixMsec != null && $Object.hasOwnProperty.call(message, "unixMsec"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.unixMsec);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link chat.Timestamp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Timestamp
         * @static
         * @param {chat.Timestamp.$Properties} message Timestamp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Timestamp.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Timestamp message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Timestamp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Timestamp & chat.Timestamp.$Shape} Timestamp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Timestamp.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.Timestamp(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                            message.unixMsec = value;
                        else
                            delete message.unixMsec;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a Timestamp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Timestamp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Timestamp & chat.Timestamp.$Shape} Timestamp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Timestamp.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Timestamp message.
         * @function verify
         * @memberof chat.Timestamp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Timestamp.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.unixMsec != null && $Object.hasOwnProperty.call(message, "unixMsec"))
                if (!$util.isInteger(message.unixMsec) && !(message.unixMsec && $util.isInteger(message.unixMsec.low) && $util.isInteger(message.unixMsec.high)))
                    return "unixMsec: integer|Long expected";
            return null;
        };

        /**
         * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Timestamp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Timestamp} Timestamp
         */
        Timestamp.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.Timestamp)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.Timestamp: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.Timestamp();
            if (object.unixMsec != null)
                if (typeof object.unixMsec === "object" ? object.unixMsec.low || object.unixMsec.high : $Number(object.unixMsec) !== 0)
                    if ($util.Long)
                        message.unixMsec = $util.Long.fromValue(object.unixMsec, true);
                    else if (typeof object.unixMsec === "string")
                        message.unixMsec = $parseInt(object.unixMsec, 10);
                    else if (typeof object.unixMsec === "number")
                        message.unixMsec = object.unixMsec;
                    else if (typeof object.unixMsec === "object")
                        message.unixMsec = new $util.LongBits(object.unixMsec.low >>> 0, object.unixMsec.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Timestamp
         * @static
         * @param {chat.Timestamp} message Timestamp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Timestamp.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.unixMsec = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.unixMsec = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            if (message.unixMsec != null && $Object.hasOwnProperty.call(message, "unixMsec"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.unixMsec = typeof message.unixMsec === "number" ? $BigInt(message.unixMsec) : $util.Long.fromBits(message.unixMsec.low >>> 0, message.unixMsec.high >>> 0, true).toBigInt();
                else if (typeof message.unixMsec === "number")
                    object.unixMsec = options.longs === $String ? $String(message.unixMsec) : message.unixMsec;
                else
                    object.unixMsec = options.longs === $String ? $util.Long.prototype.toString.call(message.unixMsec) : options.longs === $Number ? new $util.LongBits(message.unixMsec.low >>> 0, message.unixMsec.high >>> 0).toNumber(true) : message.unixMsec;
            return object;
        };

        /**
         * Converts this Timestamp to JSON.
         * @function toJSON
         * @memberof chat.Timestamp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Timestamp.prototype.toJSON = function() {
            return Timestamp.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Timestamp
         * @function getTypeUrl
         * @memberof chat.Timestamp
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Timestamp.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.Timestamp";
        };

        return Timestamp;
    })();

    chat.SendChatMessageRequest = (function() {

        /**
         * Properties of a SendChatMessageRequest.
         * @typedef {Object} chat.SendChatMessageRequest.$Properties
         * @property {string|null} [chatId] SendChatMessageRequest chatId
         * @property {string|null} [eventId] SendChatMessageRequest eventId
         * @property {string|null} [groupId] SendChatMessageRequest groupId
         * @property {string|null} [userId] SendChatMessageRequest userId
         * @property {string|null} [clientMessageId] SendChatMessageRequest clientMessageId
         * @property {string|null} [inReplyTo] SendChatMessageRequest inReplyTo
         * @property {string|null} [text] SendChatMessageRequest text
         * @property {Array.<Uint8Array>|null} [attachments] SendChatMessageRequest attachments
         * @property {string|null} [reaction] SendChatMessageRequest reaction
         * @property {string|null} [replacesId] SendChatMessageRequest replacesId
         * @property {string|null} [deletesId] SendChatMessageRequest deletesId
         * @property {"chatId"|"eventId"|"groupId"|"userId"} [recipient] SendChatMessageRequest recipient
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a SendChatMessageRequest.
         * @memberof chat
         * @interface ISendChatMessageRequest
         * @augments chat.SendChatMessageRequest.$Properties
         * @deprecated Use chat.SendChatMessageRequest.$Properties instead.
         */

        /**
         * Narrowed shape of a SendChatMessageRequest.
         * @typedef {{
         *   chatId?: string|null;
         *   eventId?: string|null;
         *   groupId?: string|null;
         *   userId?: string|null;
         *   clientMessageId?: string|null;
         *   inReplyTo?: string|null;
         *   text?: string|null;
         *   attachments?: Array.<Uint8Array>|null;
         *   reaction?: string|null;
         *   replacesId?: string|null;
         *   deletesId?: string|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ recipient?: undefined; chatId?: null; eventId?: null; groupId?: null; userId?: null }|{ recipient?: "chatId"; chatId: string; eventId?: null; groupId?: null; userId?: null }|{ recipient?: "eventId"; chatId?: null; eventId: string; groupId?: null; userId?: null }|{ recipient?: "groupId"; chatId?: null; eventId?: null; groupId: string; userId?: null }|{ recipient?: "userId"; chatId?: null; eventId?: null; groupId?: null; userId: string })
         * )} chat.SendChatMessageRequest.$Shape
         */

        /**
         * Constructs a new SendChatMessageRequest.
         * @memberof chat
         * @classdesc Represents a SendChatMessageRequest.
         * @constructor
         * @param {chat.SendChatMessageRequest.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var SendChatMessageRequest = function (properties) {
            this.attachments = [];
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * SendChatMessageRequest chatId.
         * @member {string|null|undefined} chatId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.chatId = null;

        /**
         * SendChatMessageRequest eventId.
         * @member {string|null|undefined} eventId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.eventId = null;

        /**
         * SendChatMessageRequest groupId.
         * @member {string|null|undefined} groupId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.groupId = null;

        /**
         * SendChatMessageRequest userId.
         * @member {string|null|undefined} userId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.userId = null;

        /**
         * SendChatMessageRequest clientMessageId.
         * @member {string} clientMessageId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.clientMessageId = "";

        /**
         * SendChatMessageRequest inReplyTo.
         * @member {string} inReplyTo
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.inReplyTo = "";

        /**
         * SendChatMessageRequest text.
         * @member {string} text
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.text = "";

        /**
         * SendChatMessageRequest attachments.
         * @member {Array.<Uint8Array>} attachments
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.attachments = $util.emptyArray;

        /**
         * SendChatMessageRequest reaction.
         * @member {string} reaction
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.reaction = "";

        /**
         * SendChatMessageRequest replacesId.
         * @member {string} replacesId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.replacesId = "";

        /**
         * SendChatMessageRequest deletesId.
         * @member {string} deletesId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.deletesId = "";

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * SendChatMessageRequest recipient.
         * @member {"chatId"|"eventId"|"groupId"|"userId"|undefined} recipient
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        $Object.defineProperty(SendChatMessageRequest.prototype, "recipient", {
            get: $util.oneOfGetter($oneOfFields = ["chatId", "eventId", "groupId", "userId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SendChatMessageRequest instance using the specified properties.
         * @function create
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {chat.SendChatMessageRequest.$Properties=} [properties] Properties to set
         * @returns {chat.SendChatMessageRequest} SendChatMessageRequest instance
         * @type {{
         *   (properties: chat.SendChatMessageRequest.$Shape): chat.SendChatMessageRequest & chat.SendChatMessageRequest.$Shape;
         *   (properties?: chat.SendChatMessageRequest.$Properties): chat.SendChatMessageRequest;
         * }}
         */
        SendChatMessageRequest.create = function(properties) {
            return new SendChatMessageRequest(properties);
        };

        /**
         * Encodes the specified SendChatMessageRequest message. Does not implicitly {@link chat.SendChatMessageRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {chat.SendChatMessageRequest.$Properties} message SendChatMessageRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendChatMessageRequest.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.eventId != null && $Object.hasOwnProperty.call(message, "eventId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.eventId);
            if (message.groupId != null && $Object.hasOwnProperty.call(message, "groupId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.groupId);
            if (message.userId != null && $Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.userId);
            if (message.clientMessageId != null && $Object.hasOwnProperty.call(message, "clientMessageId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.clientMessageId);
            if (message.inReplyTo != null && $Object.hasOwnProperty.call(message, "inReplyTo"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.inReplyTo);
            if (message.text != null && $Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.text);
            if (message.attachments != null && message.attachments.length)
                for (var i = 0; i < message.attachments.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.attachments[i]);
            if (message.reaction != null && $Object.hasOwnProperty.call(message, "reaction"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.reaction);
            if (message.replacesId != null && $Object.hasOwnProperty.call(message, "replacesId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.replacesId);
            if (message.deletesId != null && $Object.hasOwnProperty.call(message, "deletesId"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.deletesId);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified SendChatMessageRequest message, length delimited. Does not implicitly {@link chat.SendChatMessageRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {chat.SendChatMessageRequest.$Properties} message SendChatMessageRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendChatMessageRequest.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a SendChatMessageRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SendChatMessageRequest & chat.SendChatMessageRequest.$Shape} SendChatMessageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendChatMessageRequest.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.SendChatMessageRequest(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        message.chatId = reader.stringVerify();
                        message.recipient = "chatId";
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        message.eventId = reader.stringVerify();
                        message.recipient = "eventId";
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.groupId = reader.stringVerify();
                        message.recipient = "groupId";
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.userId = reader.stringVerify();
                        message.recipient = "userId";
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.clientMessageId = value;
                        else
                            delete message.clientMessageId;
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.inReplyTo = value;
                        else
                            delete message.inReplyTo;
                        continue;
                    }
                case 7: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.text = value;
                        else
                            delete message.text;
                        continue;
                    }
                case 8: {
                        if (wireType !== 2)
                            break;
                        if (!(message.attachments && message.attachments.length))
                            message.attachments = [];
                        message.attachments.push(reader.bytes());
                        continue;
                    }
                case 9: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.reaction = value;
                        else
                            delete message.reaction;
                        continue;
                    }
                case 10: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.replacesId = value;
                        else
                            delete message.replacesId;
                        continue;
                    }
                case 11: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.deletesId = value;
                        else
                            delete message.deletesId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a SendChatMessageRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SendChatMessageRequest & chat.SendChatMessageRequest.$Shape} SendChatMessageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendChatMessageRequest.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendChatMessageRequest message.
         * @function verify
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendChatMessageRequest.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            var properties = {};
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId")) {
                properties.recipient = 1;
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            }
            if (message.eventId != null && $Object.hasOwnProperty.call(message, "eventId")) {
                if (properties.recipient === 1)
                    return "recipient: multiple values";
                properties.recipient = 1;
                if (!$util.isString(message.eventId))
                    return "eventId: string expected";
            }
            if (message.groupId != null && $Object.hasOwnProperty.call(message, "groupId")) {
                if (properties.recipient === 1)
                    return "recipient: multiple values";
                properties.recipient = 1;
                if (!$util.isString(message.groupId))
                    return "groupId: string expected";
            }
            if (message.userId != null && $Object.hasOwnProperty.call(message, "userId")) {
                if (properties.recipient === 1)
                    return "recipient: multiple values";
                properties.recipient = 1;
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            }
            if (message.clientMessageId != null && $Object.hasOwnProperty.call(message, "clientMessageId"))
                if (!$util.isString(message.clientMessageId))
                    return "clientMessageId: string expected";
            if (message.inReplyTo != null && $Object.hasOwnProperty.call(message, "inReplyTo"))
                if (!$util.isString(message.inReplyTo))
                    return "inReplyTo: string expected";
            if (message.text != null && $Object.hasOwnProperty.call(message, "text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.attachments != null && $Object.hasOwnProperty.call(message, "attachments")) {
                if (!$Array.isArray(message.attachments))
                    return "attachments: array expected";
                for (var i = 0; i < message.attachments.length; ++i)
                    if (!(message.attachments[i] && typeof message.attachments[i].length === "number" || $util.isString(message.attachments[i])))
                        return "attachments: buffer[] expected";
            }
            if (message.reaction != null && $Object.hasOwnProperty.call(message, "reaction"))
                if (!$util.isString(message.reaction))
                    return "reaction: string expected";
            if (message.replacesId != null && $Object.hasOwnProperty.call(message, "replacesId"))
                if (!$util.isString(message.replacesId))
                    return "replacesId: string expected";
            if (message.deletesId != null && $Object.hasOwnProperty.call(message, "deletesId"))
                if (!$util.isString(message.deletesId))
                    return "deletesId: string expected";
            return null;
        };

        /**
         * Creates a SendChatMessageRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SendChatMessageRequest} SendChatMessageRequest
         */
        SendChatMessageRequest.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.SendChatMessageRequest)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.SendChatMessageRequest: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.SendChatMessageRequest();
            if (object.chatId != null)
                message.chatId = $String(object.chatId);
            if (object.eventId != null)
                message.eventId = $String(object.eventId);
            if (object.groupId != null)
                message.groupId = $String(object.groupId);
            if (object.userId != null)
                message.userId = $String(object.userId);
            if (object.clientMessageId != null)
                if (typeof object.clientMessageId !== "string" || object.clientMessageId.length)
                    message.clientMessageId = $String(object.clientMessageId);
            if (object.inReplyTo != null)
                if (typeof object.inReplyTo !== "string" || object.inReplyTo.length)
                    message.inReplyTo = $String(object.inReplyTo);
            if (object.text != null)
                if (typeof object.text !== "string" || object.text.length)
                    message.text = $String(object.text);
            if (object.attachments) {
                if (!$Array.isArray(object.attachments))
                    throw $TypeError(".chat.SendChatMessageRequest.attachments: array expected");
                message.attachments = $Array(object.attachments.length);
                for (var i = 0; i < object.attachments.length; ++i)
                    if (typeof object.attachments[i] === "string")
                        $util.base64.decode(object.attachments[i], message.attachments[i] = $util.newBuffer($util.base64.length(object.attachments[i])), 0);
                    else if (object.attachments[i].length >= 0)
                        message.attachments[i] = object.attachments[i];
            }
            if (object.reaction != null)
                if (typeof object.reaction !== "string" || object.reaction.length)
                    message.reaction = $String(object.reaction);
            if (object.replacesId != null)
                if (typeof object.replacesId !== "string" || object.replacesId.length)
                    message.replacesId = $String(object.replacesId);
            if (object.deletesId != null)
                if (typeof object.deletesId !== "string" || object.deletesId.length)
                    message.deletesId = $String(object.deletesId);
            return message;
        };

        /**
         * Creates a plain object from a SendChatMessageRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {chat.SendChatMessageRequest} message SendChatMessageRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendChatMessageRequest.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.arrays || options.defaults)
                object.attachments = [];
            if (options.defaults) {
                object.clientMessageId = "";
                object.inReplyTo = "";
                object.text = "";
                object.reaction = "";
                object.replacesId = "";
                object.deletesId = "";
            }
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId")) {
                object.chatId = message.chatId;
                if (options.oneofs)
                    object.recipient = "chatId";
            }
            if (message.eventId != null && $Object.hasOwnProperty.call(message, "eventId")) {
                object.eventId = message.eventId;
                if (options.oneofs)
                    object.recipient = "eventId";
            }
            if (message.groupId != null && $Object.hasOwnProperty.call(message, "groupId")) {
                object.groupId = message.groupId;
                if (options.oneofs)
                    object.recipient = "groupId";
            }
            if (message.userId != null && $Object.hasOwnProperty.call(message, "userId")) {
                object.userId = message.userId;
                if (options.oneofs)
                    object.recipient = "userId";
            }
            if (message.clientMessageId != null && $Object.hasOwnProperty.call(message, "clientMessageId"))
                object.clientMessageId = message.clientMessageId;
            if (message.inReplyTo != null && $Object.hasOwnProperty.call(message, "inReplyTo"))
                object.inReplyTo = message.inReplyTo;
            if (message.text != null && $Object.hasOwnProperty.call(message, "text"))
                object.text = message.text;
            if (message.attachments && message.attachments.length) {
                object.attachments = $Array(message.attachments.length);
                for (var j = 0; j < message.attachments.length; ++j)
                    object.attachments[j] = options.bytes === $String ? $util.base64.encode(message.attachments[j], 0, message.attachments[j].length) : options.bytes === $Array ? $Array.prototype.slice.call(message.attachments[j]) : message.attachments[j];
            }
            if (message.reaction != null && $Object.hasOwnProperty.call(message, "reaction"))
                object.reaction = message.reaction;
            if (message.replacesId != null && $Object.hasOwnProperty.call(message, "replacesId"))
                object.replacesId = message.replacesId;
            if (message.deletesId != null && $Object.hasOwnProperty.call(message, "deletesId"))
                object.deletesId = message.deletesId;
            return object;
        };

        /**
         * Converts this SendChatMessageRequest to JSON.
         * @function toJSON
         * @memberof chat.SendChatMessageRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendChatMessageRequest.prototype.toJSON = function() {
            return SendChatMessageRequest.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for SendChatMessageRequest
         * @function getTypeUrl
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        SendChatMessageRequest.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.SendChatMessageRequest";
        };

        return SendChatMessageRequest;
    })();

    chat.ChatMessage = (function() {

        /**
         * Properties of a ChatMessage.
         * @typedef {Object} chat.ChatMessage.$Properties
         * @property {string|null} [messageId] ChatMessage messageId
         * @property {string|null} [chatId] ChatMessage chatId
         * @property {string|null} [clientMessageId] ChatMessage clientMessageId
         * @property {chat.Avatar.$Properties|null} [sender] ChatMessage sender
         * @property {chat.Timestamp.$Properties|null} [receivedAt] ChatMessage receivedAt
         * @property {string|null} [inReplyTo] ChatMessage inReplyTo
         * @property {string|null} [text] ChatMessage text
         * @property {Array.<string>|null} [thumbnailIds] ChatMessage thumbnailIds
         * @property {string|null} [reaction] ChatMessage reaction
         * @property {string|null} [replacesId] ChatMessage replacesId
         * @property {string|null} [deletesId] ChatMessage deletesId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a ChatMessage.
         * @memberof chat
         * @interface IChatMessage
         * @augments chat.ChatMessage.$Properties
         * @deprecated Use chat.ChatMessage.$Properties instead.
         */

        /**
         * Shape of a ChatMessage.
         * @typedef {chat.ChatMessage.$Properties} chat.ChatMessage.$Shape
         */

        /**
         * Constructs a new ChatMessage.
         * @memberof chat
         * @classdesc Represents a ChatMessage.
         * @constructor
         * @param {chat.ChatMessage.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        var ChatMessage = function (properties) {
            this.thumbnailIds = [];
            if (properties)
                for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * ChatMessage messageId.
         * @member {string} messageId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.messageId = "";

        /**
         * ChatMessage chatId.
         * @member {string} chatId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.chatId = "";

        /**
         * ChatMessage clientMessageId.
         * @member {string} clientMessageId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.clientMessageId = "";

        /**
         * ChatMessage sender.
         * @member {chat.Avatar.$Properties|null|undefined} sender
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.sender = null;

        /**
         * ChatMessage receivedAt.
         * @member {chat.Timestamp.$Properties|null|undefined} receivedAt
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.receivedAt = null;

        /**
         * ChatMessage inReplyTo.
         * @member {string} inReplyTo
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.inReplyTo = "";

        /**
         * ChatMessage text.
         * @member {string} text
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.text = "";

        /**
         * ChatMessage thumbnailIds.
         * @member {Array.<string>} thumbnailIds
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.thumbnailIds = $util.emptyArray;

        /**
         * ChatMessage reaction.
         * @member {string} reaction
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.reaction = "";

        /**
         * ChatMessage replacesId.
         * @member {string} replacesId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.replacesId = "";

        /**
         * ChatMessage deletesId.
         * @member {string} deletesId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.deletesId = "";

        /**
         * Creates a new ChatMessage instance using the specified properties.
         * @function create
         * @memberof chat.ChatMessage
         * @static
         * @param {chat.ChatMessage.$Properties=} [properties] Properties to set
         * @returns {chat.ChatMessage} ChatMessage instance
         * @type {{
         *   (properties: chat.ChatMessage.$Shape): chat.ChatMessage & chat.ChatMessage.$Shape;
         *   (properties?: chat.ChatMessage.$Properties): chat.ChatMessage;
         * }}
         */
        ChatMessage.create = function(properties) {
            return new ChatMessage(properties);
        };

        /**
         * Encodes the specified ChatMessage message. Does not implicitly {@link chat.ChatMessage.verify|verify} messages.
         * @function encode
         * @memberof chat.ChatMessage
         * @static
         * @param {chat.ChatMessage.$Properties} message ChatMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMessage.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.messageId != null && $Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            if (message.clientMessageId != null && $Object.hasOwnProperty.call(message, "clientMessageId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.clientMessageId);
            if (message.sender != null && $Object.hasOwnProperty.call(message, "sender"))
                $root.chat.Avatar.encode(message.sender, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.receivedAt != null && $Object.hasOwnProperty.call(message, "receivedAt"))
                $root.chat.Timestamp.encode(message.receivedAt, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.inReplyTo != null && $Object.hasOwnProperty.call(message, "inReplyTo"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.inReplyTo);
            if (message.text != null && $Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.text);
            if (message.thumbnailIds != null && message.thumbnailIds.length)
                for (var i = 0; i < message.thumbnailIds.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.thumbnailIds[i]);
            if (message.reaction != null && $Object.hasOwnProperty.call(message, "reaction"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.reaction);
            if (message.replacesId != null && $Object.hasOwnProperty.call(message, "replacesId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.replacesId);
            if (message.deletesId != null && $Object.hasOwnProperty.call(message, "deletesId"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.deletesId);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (var i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ChatMessage message, length delimited. Does not implicitly {@link chat.ChatMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ChatMessage
         * @static
         * @param {chat.ChatMessage.$Properties} message ChatMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMessage.encodeDelimited = function(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ChatMessage message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ChatMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ChatMessage & chat.ChatMessage.$Shape} ChatMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMessage.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.chat.ChatMessage(), value;
            while (reader.pos < end) {
                var start = reader.pos;
                var tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                var wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.messageId = value;
                        else
                            delete message.messageId;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.chatId = value;
                        else
                            delete message.chatId;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.clientMessageId = value;
                        else
                            delete message.clientMessageId;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.sender = $root.chat.Avatar.decode(reader, reader.uint32(), $undefined, _depth + 1, message.sender);
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        message.receivedAt = $root.chat.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.receivedAt);
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.inReplyTo = value;
                        else
                            delete message.inReplyTo;
                        continue;
                    }
                case 7: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.text = value;
                        else
                            delete message.text;
                        continue;
                    }
                case 8: {
                        if (wireType !== 2)
                            break;
                        if (!(message.thumbnailIds && message.thumbnailIds.length))
                            message.thumbnailIds = [];
                        message.thumbnailIds.push(reader.stringVerify());
                        continue;
                    }
                case 9: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.reaction = value;
                        else
                            delete message.reaction;
                        continue;
                    }
                case 10: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.replacesId = value;
                        else
                            delete message.replacesId;
                        continue;
                    }
                case 11: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.deletesId = value;
                        else
                            delete message.deletesId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Decodes a ChatMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ChatMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ChatMessage & chat.ChatMessage.$Shape} ChatMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMessage.decodeDelimited = function(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatMessage message.
         * @function verify
         * @memberof chat.ChatMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatMessage.verify = function (message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.messageId != null && $Object.hasOwnProperty.call(message, "messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.clientMessageId != null && $Object.hasOwnProperty.call(message, "clientMessageId"))
                if (!$util.isString(message.clientMessageId))
                    return "clientMessageId: string expected";
            if (message.sender != null && $Object.hasOwnProperty.call(message, "sender")) {
                var error = $root.chat.Avatar.verify(message.sender, _depth + 1);
                if (error)
                    return "sender." + error;
            }
            if (message.receivedAt != null && $Object.hasOwnProperty.call(message, "receivedAt")) {
                var error = $root.chat.Timestamp.verify(message.receivedAt, _depth + 1);
                if (error)
                    return "receivedAt." + error;
            }
            if (message.inReplyTo != null && $Object.hasOwnProperty.call(message, "inReplyTo"))
                if (!$util.isString(message.inReplyTo))
                    return "inReplyTo: string expected";
            if (message.text != null && $Object.hasOwnProperty.call(message, "text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.thumbnailIds != null && $Object.hasOwnProperty.call(message, "thumbnailIds")) {
                if (!$Array.isArray(message.thumbnailIds))
                    return "thumbnailIds: array expected";
                for (var i = 0; i < message.thumbnailIds.length; ++i)
                    if (!$util.isString(message.thumbnailIds[i]))
                        return "thumbnailIds: string[] expected";
            }
            if (message.reaction != null && $Object.hasOwnProperty.call(message, "reaction"))
                if (!$util.isString(message.reaction))
                    return "reaction: string expected";
            if (message.replacesId != null && $Object.hasOwnProperty.call(message, "replacesId"))
                if (!$util.isString(message.replacesId))
                    return "replacesId: string expected";
            if (message.deletesId != null && $Object.hasOwnProperty.call(message, "deletesId"))
                if (!$util.isString(message.deletesId))
                    return "deletesId: string expected";
            return null;
        };

        /**
         * Creates a ChatMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ChatMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ChatMessage} ChatMessage
         */
        ChatMessage.fromObject = function (object, _depth) {
            if (object instanceof $root.chat.ChatMessage)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".chat.ChatMessage: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var message = new $root.chat.ChatMessage();
            if (object.messageId != null)
                if (typeof object.messageId !== "string" || object.messageId.length)
                    message.messageId = $String(object.messageId);
            if (object.chatId != null)
                if (typeof object.chatId !== "string" || object.chatId.length)
                    message.chatId = $String(object.chatId);
            if (object.clientMessageId != null)
                if (typeof object.clientMessageId !== "string" || object.clientMessageId.length)
                    message.clientMessageId = $String(object.clientMessageId);
            if (object.sender != null) {
                if (!$util.isObject(object.sender))
                    throw $TypeError(".chat.ChatMessage.sender: object expected");
                message.sender = $root.chat.Avatar.fromObject(object.sender, _depth + 1);
            }
            if (object.receivedAt != null) {
                if (!$util.isObject(object.receivedAt))
                    throw $TypeError(".chat.ChatMessage.receivedAt: object expected");
                message.receivedAt = $root.chat.Timestamp.fromObject(object.receivedAt, _depth + 1);
            }
            if (object.inReplyTo != null)
                if (typeof object.inReplyTo !== "string" || object.inReplyTo.length)
                    message.inReplyTo = $String(object.inReplyTo);
            if (object.text != null)
                if (typeof object.text !== "string" || object.text.length)
                    message.text = $String(object.text);
            if (object.thumbnailIds) {
                if (!$Array.isArray(object.thumbnailIds))
                    throw $TypeError(".chat.ChatMessage.thumbnailIds: array expected");
                message.thumbnailIds = $Array(object.thumbnailIds.length);
                for (var i = 0; i < object.thumbnailIds.length; ++i)
                    message.thumbnailIds[i] = $String(object.thumbnailIds[i]);
            }
            if (object.reaction != null)
                if (typeof object.reaction !== "string" || object.reaction.length)
                    message.reaction = $String(object.reaction);
            if (object.replacesId != null)
                if (typeof object.replacesId !== "string" || object.replacesId.length)
                    message.replacesId = $String(object.replacesId);
            if (object.deletesId != null)
                if (typeof object.deletesId !== "string" || object.deletesId.length)
                    message.deletesId = $String(object.deletesId);
            return message;
        };

        /**
         * Creates a plain object from a ChatMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ChatMessage
         * @static
         * @param {chat.ChatMessage} message ChatMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatMessage.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            var object = {};
            if (options.arrays || options.defaults)
                object.thumbnailIds = [];
            if (options.defaults) {
                object.messageId = "";
                object.chatId = "";
                object.clientMessageId = "";
                object.sender = null;
                object.receivedAt = null;
                object.inReplyTo = "";
                object.text = "";
                object.reaction = "";
                object.replacesId = "";
                object.deletesId = "";
            }
            if (message.messageId != null && $Object.hasOwnProperty.call(message, "messageId"))
                object.messageId = message.messageId;
            if (message.chatId != null && $Object.hasOwnProperty.call(message, "chatId"))
                object.chatId = message.chatId;
            if (message.clientMessageId != null && $Object.hasOwnProperty.call(message, "clientMessageId"))
                object.clientMessageId = message.clientMessageId;
            if (message.sender != null && $Object.hasOwnProperty.call(message, "sender"))
                object.sender = $root.chat.Avatar.toObject(message.sender, options, _depth + 1);
            if (message.receivedAt != null && $Object.hasOwnProperty.call(message, "receivedAt"))
                object.receivedAt = $root.chat.Timestamp.toObject(message.receivedAt, options, _depth + 1);
            if (message.inReplyTo != null && $Object.hasOwnProperty.call(message, "inReplyTo"))
                object.inReplyTo = message.inReplyTo;
            if (message.text != null && $Object.hasOwnProperty.call(message, "text"))
                object.text = message.text;
            if (message.thumbnailIds && message.thumbnailIds.length) {
                object.thumbnailIds = $Array(message.thumbnailIds.length);
                for (var j = 0; j < message.thumbnailIds.length; ++j)
                    object.thumbnailIds[j] = message.thumbnailIds[j];
            }
            if (message.reaction != null && $Object.hasOwnProperty.call(message, "reaction"))
                object.reaction = message.reaction;
            if (message.replacesId != null && $Object.hasOwnProperty.call(message, "replacesId"))
                object.replacesId = message.replacesId;
            if (message.deletesId != null && $Object.hasOwnProperty.call(message, "deletesId"))
                object.deletesId = message.deletesId;
            return object;
        };

        /**
         * Converts this ChatMessage to JSON.
         * @function toJSON
         * @memberof chat.ChatMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatMessage.prototype.toJSON = function() {
            return ChatMessage.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ChatMessage
         * @function getTypeUrl
         * @memberof chat.ChatMessage
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ChatMessage.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/chat.ChatMessage";
        };

        return ChatMessage;
    })();

    return chat;
})();

module.exports = $root;
